import React,{useState,useEffect,useRef} from "react";
import './ReleaseMusic.css'
import { Trans, useTranslation} from 'react-i18next'
import DragDots from './../../../../images/drag.png'
import MissingTrackDetailsIcon from './../../../../images/missingtrackdetailsicon.png'
import AudioButton from "./AudioBtn";
import TrackFolderIcon from './../../../../images/trackfoldericon.png'
import DeleteTrackIcon from './../../../../images/deletetrackicon.png'
import UploadTrackBox from './../../../../images/uploadtrackbox.png'
import ReactModal from 'react-modal';
import DisclaimerPopup from './../../../../images/settingsdisclaimericon.png'
import ArrowDown from './../../../../images/arrowdown.png'
import Select from 'react-select'
import crossicon from './../../../../images/crossicon.png'
import MoreTrackInfo from './../../../../images/moretrackdetails.png'
import EditIcon from './../../../../images/editicon.png'
import DeleteIcon from './../../../../images/deleteicon.png'
import { useSwitch } from '@mui/base/useSwitch';
import { styled } from '@mui/system';
import clsx from 'clsx';
import {useLocation,useNavigate} from "react-router-dom";
import CrossIcon from './../../../../images/crossicon.png'
import { useJwt, decodeToken } from "react-jwt";
import Cookies from "universal-cookie";
import axios from 'axios' 


var primaryChecked =false
var featured1Checked =false
var featured2Checked =false
var featured3Checked =false
var featured4Checked =false
var featured5Checked =false
var featured6Checked =false

function TrackDetails({nextBtn,setNextBtn,pagePath,setPagePath,files,setFiles,artistName,trackUploaded,setTrackUploaded}) { 
    const ref = useRef(null)
    const fileref = useRef()
    const addRef = useRef(null)
    const {t, i18n } = useTranslation();
    const [deletePopup,setDeletePopup] = useState(false)
    const [deleteTrackIndex,setDeleteTrackIndex] = useState(false)
    const [checkAssetArr,setCheckAssetArr] = useState(0)
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });
    const location = useLocation();
    // const [files,setFiles] = useState([])
    const [artistId,setArtistId] = useState();
    const [Trackname,setTrackname] = useState("");
    const [newArtistName,setnewArtistName] = useState("");
    const [newArtistISNI,setnewArtistISNI] = useState("");
    const [addArtistDisclaimer,setAddArtistDisclaimer] = useState(false);
    const [advanceTrackFields,setAdvanceTrackFields] = useState(false);
    const [tracklanguageclass,setTrackLanguageClass] = useState("TrackLanguageModule")
    const [lyricsclass,setLyricsClass] = useState("LyricsModule")
    const [role,setRole] = useState("")
    const [trackartist,setTrackArtist] = useState("")
    const [artistRoles,setArtistRoles] = useState([])
    const [instrument,setInstruments] = useState("")
    const [artistInstuments,setArtistInstruments] = useState([])
    const [roleToggle,setRoleToggle] = useState(false)
    const [artistToggle,setArtistToggle] = useState(false)
    const [instrumentToggle,setInstumentToggle] = useState(false)
    const [publishers,setPublisher] = useState("")
    const [composer,setComposer] = useState("")
    const [lyrics,setLyrics] = useState("")
    const [trackartists,setTrackArtists] = useState([])
    const [trackartistsIds,setTrackArtistsIds] = useState([])
    const [trackContributors,setTrackContributors] = useState([])
    const [trackContributorsIds,setTrackContributorsIds] = useState([])
    const [trackPublishers,setTrackPublishers] = useState([])
    const [trackPublishersIds,setTrackPublishersIds] = useState([])

    const [fugaIdTimes,setFugaIdTimes] = useState(0)
    const [fugaPersonIdTimes,setFugaPersonIdTimes] = useState(0)

    const [artistIds,setArtistIds] = useState([])
    const [publisherIds,setPublisherIds] = useState([])
    const [contributorIds,setContributorIds] = useState([])

    const [contributor,setContributor] = useState("")
    const [producer1,setProducer1] = useState("")
    const [viewProducer2,setViewProducer2] = useState(false)
    const [viewProducer3,setViewProducer3] = useState(false)
    const [producer2,setProducer2] = useState("")
    const [producer3,setProducer3] = useState("")
    const [songwriter1,setSongwriter1] = useState("")
    const [viewSongwriter2,setViewSongwriter2] = useState(false)
    const [viewSongwriter3,setViewSongwriter3] = useState(false)
    const [songwriter2,setSongwriter2] = useState("")
    const [songwriter3,setSongwriter3] = useState("")
    const [featuredArtist1,setFeaturedArtist1] = useState("")
    const [viewFeaturedArtist2,setViewFeaturedArtist2] = useState(false)
    const [viewFeaturedArtist3,setViewFeaturedArtist3] = useState(false)
    const [featuredArtist2,setFeaturedArtist2] = useState("")
    const [featuredArtist3,setFeaturedArtist3] = useState("")
    const [trackMetadatLanguage,setTrackMetadataLanguage] = useState("")
    const [explicitContent,setExplicitContent] = useState("")
    const [Price,setPrice] = useState(0)
    const [AudioLanguage,setAudioLanguage] = useState("")
    const [RadioEdit,setRadioEdit] = useState(false)
    const [songwriter1Id,setSongwriter1Id] = useState(0)
    const [songwriter2Id,setSongwriter2Id] = useState(0)
    const [songwriter3Id,setSongwriter3Id] = useState(0)
    const [producer1Id,setProducer1Id] = useState(0)
    const [producer2Id,setProducer2Id] = useState(0)
    const [producer3Id,setProducer3Id] = useState(0)
    const [featuredArtist1Id,setfeaturedArtistId1] = useState(0)
    const [featuredArtist2Id,setfeaturedArtistId2] = useState(0)
    const [featuredArtist3Id,setfeaturedArtistId3] = useState(0)
    const [unsavedChanges,setUnsavedChanges] = useState(false)
    const [unsavedChangesPopup,setUnsavedChangesPopup] = useState(false)

    const [publisherId,setPublisherId] = useState(0)
    const [contributorId,setContributorId] = useState(0)
    const [addPublisherPopup,setAddPublisherPopup] = useState(false)
    const [editPublisherPopup,setEditPublisherPopup] = useState(false)

    const [songwriter1Error,setSongwriter1Error] = useState(false)
    const [songwriter2Error,setSongwriter2Error] = useState(false)
    const [songwriter3Error,setSongwriter3Error] = useState(false)
    const [producer1Error,setProducer1Error] = useState(false)
    const [producer2Error,setProducer2Error] = useState(false)
    const [producer3Error,setProducer3Error] = useState(false)
    const [featuredArtist1Error,setFeaturedArtist1Error] = useState(false)
    const [featuredArtist2Error,setFeaturedArtist2Error] = useState(false)
    const [featuredArtist3Error,setFeaturedArtist3Error] = useState(false)

    const [addContributorPopup,setAddContributorPopup] = useState(false)
    const [editContributorPopup,setEditContibutorPopup] = useState(false)

    const [createArtistPopup,setCreateArtistPopup] = useState(false)
    const [audiolength,setAudioLength] = useState([])

    const [upadateFilelist,setUpdateFileList] = useState(0);
    const [playstate,setPlayState] = useState([]);
    const [popupId,setPopupId] = useState(0)
    const [trackPopup,setTrackPopup] = useState(false)
   

    const TrackItemDrag = useRef()
    const TrackItemDragOver = useRef()
    const [dragActive , setDragActive] = useState(false)

    const [LanguageOptions,setLangOptions] = useState([])
    const [instrumentOptions,setInstOptions] = useState([])
    const [roleOptions,setRoleOptions] = useState([])
    const [popupstate,setPopupState] = useState("From track details")

    const [fugaArtistId,setFugaArtistIds] = useState([])
    const [fugaPersonId,setFugaPersonIds] = useState([])

    //  const instrumentOptions = [{value:'Accordion',label:'Accordion'},    {value:'AcousticBaritoneGuitar',label:'Acoustic Baritone Guitar'},    {value:'AcousticBassGuitar',label:'Acoustic Bass Guitar'},    {value:'AcousticFretlessGuitar',label:'Acoustic Fretless Guitar'},    {value:'AcousticGuitar',label:'Acoustic Guitar'},    {value:'AltoClarinet',label:'Alto Clarinet'},    {value:'AltoFlute',label:'Alto Flute'},    {value:'AltoHorn',label:'Alto Horn'},    {value:'AltoRecorder',label:'Alto Recorder'},    {value:'AltoSaxophone',label:'Alto Saxophone'},    {value:'AltoTrombone',label:'Alto Trombone'},    {value:'AltoViolin',label:'Alto Violin'},    {value:'AltoVocals',label:'Alto Vocals'},{value:'AppalachianDulcimer',label:'Appalachian Dulcimer'},    {value:'Archlute',label:'Archlute'},    {value:'Autoharp',label:'Autoharp'},    {value:'BackgroundVocals',label:'Background Vocals'},    {value:'Baglama',label:'Baglama'},    {value:'Bagpipes',label:'Bagpipes'},    {value:'Balafon',label:'Balafon'},    {value:'Balalaika',label:'Balalaika'},    {value:'Bandoneon',label:'Bandoneon'},    {value:'Bandurria',label:'Bandurria'},    {value:'Banjo',label:'Banjo'},    {value:'Bansuri',label:'Bansuri'},    {value:'Barbat',label:'Barbat'},{value:'BaritoneGuitar',label:'Baritone Guitar'},    {value:'BaritoneHorn',label:'Baritone Horn'},    {value:'BaritoneVocals',label:'Baritone Vocals'},    {value:'BaroqueGuitar',label:'Baroque Guitar'},    {value:'BarrelOrgan',label:'Barrel Organ'},    {value:'Bass',label:'Bass'},    {value:'BassClarinet',label:'Bass Clarinet'},    {value:'BassDrum',label:'Bass Drum'},    {value:'BassFlute',label:'Bass Flute'},    {value:'BassGuitar',label:'Bass Guitar'},    {value:'BassHarmonica',label:'Bass Harmonica'},    {value:'BassOboe',label:'Bass Oboe'},    {value:'BassRecorder',label:'Bass Recorder'},    {value:'BassSaxophone',label:'Bass Saxophone'},    {value:'BassTrombone',label:'Bass Trombone'},    {value:'BassTrumpet',label:'Bass Trumpet'},    {value:'BassVocals',label:'Bass Vocals'},    {value:'BassetClarinet',label:'Basset Clarinet'},    {value:'BassetHorn',label:'Basset Horn'},    {value:'Bassoon',label:'Bassoon'},    {value:'BatáDrums',label:'Batá Drums'},    {value:'BeatBoxing',label:'Beat Boxing'},    {value:'Bells',label:'Bells'},    {value:'Bendir',label:'Bendir'},    {value:'Berimbau',label:'Berimbau'},    {value:'Biwa',label:'Biwa'},    {value:'Bonang',label:'Bonang'},    {value:'Bongos',label:'Bongos'},
    // {value:'Bouzouki',label:'Bouzouki'},    {value:'Bugle',label:'Bugle'},    {value:'ButtonAccordion',label:'Button Accordion'},    {value:'C-MelodySax',label:'C-Melody Sax'},    {value:'Cajon',label:'Cajon'},    {value:'Calliope',label:'Calliope'},    {value:'Castanets',label:'Castanets'},{value:'Cavaquinho',label:'Cavaquinho'},    {value:'Caxixi',label:'Caxixi'},{value:'Celeste',label:'Celeste'},{value:'Cello',label:'Cello'},    {value:'ChamberOrgan',label:'Chamber Organ'},{value:'Chamberlin',label:'Chamberlin'},    {value:'ChantVocals',label:'Chant Vocals'},{value:'ChapmanStick',label:'Chapman Stick'},{value:'Charango',label:'Charango'},{value:'Chekere',label:'Chekere'},    {value:'ChestOrgan',label:'Chest Organ'},    {value:'Chimes',label:'Chimes'},{value:'ChromaticHarmonica',label:'Chromatic Harmonica'},    {value:'Cimbalom',label:'Cimbalom'},    {value:'Cittern',label:'Cittern'},    {value:'Clarinet',label:'Clarinet'},    {value:'ClassicalGuitar',label:'Classical Guitar'},    {value:'Claves',label:'Claves'},    {value:'Clavichord',label:'Clavichord'},    {value:'Clavinet',label:'Clavinet'},    {value:'ConcertHarp',label:'Concert Harp'},    {value:'Concertina',label:'Concertina'},    {value:'ConchShells',label:'Conch Shells'},    {value:'Congas',label:'Congas'},    {value:'Contrabass',label:'Contrabass'},    {value:'ContrabassClarinet',label:'Contrabass Clarinet'},    {value:'ContrabassFlute',label:'Contrabass Flute'},    {value:'ContrabassRecorder',label:'Contrabass Recorder'},    {value:'ContrabassSarrusophone',label:'Contrabass Sarrusophone'},    {value:'ContrabassSaxophone',label:'Contrabass Saxophone'},    {value:'ContrabassTrombone',label:'Contrabass Trombone'},    {value:'Contrabassoon',label:'Contrabassoon'},    {value:'ContraltoClarinet',label:'Contralto Clarinet'},    {value:'ContraltoVocals',label:'Contralto Vocals'},    {value:'Cornet',label:'Cornet'},    {value:'Cornett',label:'Cornett'},    {value:'CounterTenor',label:'Counter Tenor'},    {value:'Cowbell',label:'Cowbell'},    {value:'Crotales',label:'Crotales'},    {value:'Crumhorn',label:'Crumhorn'},    {value:'Cuatro',label:'Cuatro'},    {value:'Cuesnophone',label:'Cuesnophone'},    {value:'Curtal',label:'Curtal'},    {value:'Cymbals',label:'Cymbals'},    {value:'Daf',label:'Daf'},    {value:'Dhol',label:'Dhol'},    {value:'DiddleyBow',label:'Diddley Bow'},    {value:'Didgeridoo',label:'Didgeridoo'},    {value:'Djembe',label:'Djembe'},    {value:'DobroGuitar',label:'Dobro Guitar'},
    // {value:'Doumbek',label:'Doumbek'},    {value:'DoubleBass',label:'Double Bass'},    {value:'DrumMachine',label:'Drum Machine'},    {value:'Drums',label:'Drums'},    {value:'Duduk',label:'Duduk'},    {value:'Dulcimer',label:'Dulcimer'},    {value:'E-Bow',label:'E-Bow'},    {value:'ElectricBassGuitar',label:'Electric Bass Guitar'},    {value:'ElectricCello',label:'Electric Cello'},{value:'ElectricFretlessGuitar',label:'Electric Fretless Guitar'},    {value:'ElectricGuitar',label:'Electric Guitar'},    {value:'ElectricPiano',label:'Electric Piano'},    {value:'ElectricSitar',label:'Electric Sitar'},    {value:'ElectricUprightBass',label:'Electric Upright Bass'},    {value:'ElectricViola',label:'Electric Viola'},    {value:'ElectricViolin',label:'Electric Violin'},    {value:'ElectronicValveInstrument',label:'Electronic Valve Instrument'},    {value:'ElectronicWindInstrument',label:'Electronic Wind Instrument'},    {value:'EnglishHorn',label:'English Horn'},{value:'Euphonium',label:'Euphonium'},{value:'Farfisa',label:'Farfisa'},    {value:'FenderRhodes',label:'Fender Rhodes'},    {value:'Fiddle',label:'Fiddle'},    {value:'Fife',label:'Fife'},    {value:'FingerCymbals',label:'Finger Cymbals'},    {value:'FingerSnaps',label:'Finger Snaps'},    {value:'FlamencoGuitar',label:'Flamenco Guitar'},    {value:'Flugelhorn',label:'Flugelhorn'},    {value:'Flute',label:'Flute'},    {value:'Fortepiano',label:'Fortepiano'},    {value:'FrameDrum',label:'Frame Drum'},    {value:'FrenchHorn',label:'French Horn'},    {value:'Gendèr',label:'Gendèr'},    {value:'Ghatam',label:'Ghatam'},    {value:'Gitern',label:'Gitern'},    {value:'Glockenspiel',label:'Glockenspiel'},    {value:'Gong',label:'Gong'},    {value:'Güiro',label:'Güiro'},    {value:'Guitar',label:'Guitar'},    {value:'Guitars',label:'Guitars'},    {value:'Gut-StringGuitar',label:'Gut-String Guitar'},    {value:'Hag\'houge',label:'Hag\'houge'},    {value:'HammeredDulcimer',label:'Hammered Dulcimer'},    {value:'HammondOrgan',label:'Hammond Organ'},    {value:'Handclaps',label:'Handclaps'},    {value:'Hardingfele',label:'Hardingfele'},    {value:'Harmonica',label:'Harmonica'},    {value:'Harmonium',label:'Harmonium'},    {value:'HarmonyVocals',label:'Harmony Vocals'},    {value:'Harp',label:'Harp'},    {value:'Harpsichord',label:'Harpsichord'},    {value:'HornSection',label:'Horn Section'},    {value:'Horns',label:'Horns'},    {value:'HurdyGurdy',label:'Hurdy Gurdy'},    {value:'Kalimba',label:'Kalimba'},
    // {value:'Karkaba',label:'Karkaba'},    {value:'Kazoo',label:'Kazoo'},    {value:'Kendang',label:'Kendang'},    {value:'Kenong/Kethuk',label:'Kenong/Kethuk'},    {value:'KeyboardBass',label:'Keyboard Bass'},    {value:'Keyboards',label:'Keyboards'},    {value:'Keytar',label:'Keytar'},    {value:'Kora',label:'Kora'},    {value:'Koto',label:'Koto'},    {value:'LapSteelGuitar',label:'Lap Steel Guitar'},    {value:'LowWhistle',label:'Low Whistle'},    {value:'Lute',label:'Lute'},    {value:'Lyricon',label:'Lyricon'},    {value:'Mandocello',label:'Mandocello'},    {value:'Mandola',label:'Mandola'},    {value:'Mandolin',label:'Mandolin'},    {value:'Manzello',label:'Manzello'},    {value:'Maracas',label:'Maracas'},    {value:'Marimba',label:'Marimba'},    {value:'Mellophone',label:'Mellophone'},    {value:'Mellophonium',label:'Mellophonium'},    {value:'Mellotron',label:'Mellotron'},    {value:'Melodica',label:'Melodica'},    {value:'Mezzo-sopranoVocals',label:'Mezzo-soprano Vocals'},    {value:'ModularSynth',label:'Modular Synth'},    {value:'MouthOrgan',label:'Mouth Organ'},    {value:'Mridangam',label:'Mridangam'},    {value:'Musette',label:'Musette'},    {value:'Ney',label:'Ney'},    {value:'Noises',label:'Noises'},    {value:'Nylon-StringGuitar',label:'Nylon-String Guitar'},    {value:'Oboe',label:'Oboe'},    {value:'OboeD\'Amore',label:'Oboe D\'Amore'},    {value:'Ocarina',label:'Ocarina'},    {value:'Omnichord',label:'Omnichord'},    {value:'OndesMartenot',label:'Ondes Martenot'},    {value:'Organ',label:'Organ'},    {value:'Oud',label:'Oud'},    {value:'PanFlute',label:'Pan Flute'},    {value:'Panpipes',label:'Panpipes'},    {value:'ParlourGuitar',label:'Parlour Guitar'},    {value:'PedalSteelGuitar',label:'Pedal Steel Guitar'},    {value:'Peking',label:'Peking'},    {value:'PennyWhistle',label:'Penny Whistle'},    {value:'Percussion',label:'Percussion'},    {value:'Piano',label:'Piano'},    {value:'Piccolo',label:'Piccolo'},    {value:'PiccoloBass',label:'Piccolo Bass'},    {value:'PiccoloOboe',label:'Piccolo Oboe'},    {value:'PiccoloTrumpet',label:'Piccolo Trumpet'},    {value:'PikasaGuitar',label:'Pikasa Guitar'},    {value:'PipeOrgan',label:'Pipe Organ'},    {value:'PortugueseGuitar',label:'Portuguese Guitar'},    {value:'PreparedPiano',label:'Prepared Piano'},    {value:'Psaltery',label:'Psaltery'},    {value:'Rebab',label:'Rebab'},    {value:'Rebec',label:'Rebec'},    {value:'Recorder',label:'Recorder'},
    // {value:'ReedOrgan',label:'Reed Organ'},    {value:'RequintoGuitar',label:'Requinto Guitar'},    {value:'RhodesPiano',label:'Rhodes Piano'},    {value:'RhythmGuitar',label:'Rhythm Guitar'},    {value:'Sackbut',label:'Sackbut'},    {value:'Sampler',label:'Sampler'},    {value:'Santoor',label:'Santoor'}, {value:'Santur',label:'Santur'},    {value:'Sarangi',label:'Sarangi'},    {value:'Sarod',label:'Sarod'},    {value:'Saron',label:'Saron'},    {value:'Sarrusophone',label:'Sarrusophone'},    {value:'Saxello',label:'Saxello'},    {value:'Saxophone',label:'Saxophone'},    {value:'Saz',label:'Saz'},    {value:'Serpent',label:'Serpent'},    {value:'Shakers',label:'Shakers'},    {value:'Shakuhachi',label:'Shakuhachi'},    {value:'Shamisen',label:'Shamisen'},    {value:'Shawm',label:'Shawm'},    {value:'Shekere',label:'Shekere'},    {value:'Shenai',label:'Shenai'},    {value:'Sitar',label:'Sitar'},    {value:'SleighBells',label:'Sleigh Bells'},    {value:'Slenthem',label:'Slenthem'},    {value:'SlideGuitar',label:'Slide Guitar'},    {value:'SlideSaxophone',label:'Slide Saxophone'},   {value:'SlideTrumpet',label:'Slide Trumpet'},    {value:'SlideWhistle',label:'Slide Whistle'},    {value:'SnareDrum',label:'Snare Drum'},    {value:'SopraninoClarinet',label:'Sopranino Clarinet'},    {value:'SopraninoSaxophone',label:'Sopranino Saxophone'},    {value:'Soprano',label:'Soprano'},    {value:'SopranoClarinet',label:'Soprano Clarinet'},    {value:'SopranoFlute',label:'Soprano Flute'},    {value:'SopranoRecorder',label:'Soprano Recorder'},    {value:'SopranoSaxophone',label:'Soprano Saxophone'},    {value:'SopranoViolin',label:'Soprano Violin'},    {value:'SopranoVocals',label:'Soprano Vocals'},    {value:'Sousaphone',label:'Sousaphone'},    {value:'SpanishGuitar',label:'Spanish Guitar'},    {value:'Spinet',label:'Spinet'},    {value:'Spoons',label:'Spoons'},    {value:'SteelDrums',label:'Steel Drums'},    {value:'Strings',label:'Strings'},    {value:'Stritch',label:'Stritch'},    {value:'Surdo',label:'Surdo'},    {value:'Synclavier',label:'Synclavier'},    {value:'Synthesizer',label:'Synthesizer'},    {value:'Tabla',label:'Tabla'},    {value:'TaborPipe',label:'Tabor Pipe'},    {value:'TackPiano',label:'Tack Piano'},    {value:'Talkbox',label:'Talkbox'},    {value:'TalkingDrum',label:'Talking Drum'},    {value:'Tamborim',label:'Tamborim'},    {value:'Tamboura',label:'Tamboura'},    {value:'Tambourine',label:'Tambourine'},    {value:'Tanpura',label:'Tanpura'},
    // {value:'Tarogato',label:'Tarogato'},    {value:'TempleBlocks',label:'Temple Blocks'},    {value:'TenorBanjo',label:'Tenor Banjo'},    {value:'TenorDrum',label:'Tenor Drum'},    {value:'TenorGuitar',label:'Tenor Guitar'},    {value:'TenorHorn',label:'Tenor Horn'},    {value:'TenorRecorder',label:'Tenor Recorder'},    {value:'TenorSaxophone',label:'Tenor Saxophone'},    {value:'TenorTrombone',label:'Tenor Trombone'},    {value:'TenorViolin',label:'Tenor Violin'},    {value:'TenorVocals',label:'Tenor Vocals'},    {value:'Thavil',label:'Thavil'},    {value:'Theorbo',label:'Theorbo'},    {value:'Theremin',label:'Theremin'},    {value:'Timbales',label:'Timbales'},    {value:'Timpani',label:'Timpani'},    {value:'TinWhistle',label:'Tin Whistle'},    {value:'ToyPiano',label:'Toy Piano'},    {value:'Traverso',label:'Traverso'},    {value:'Tres',label:'Tres'},    {value:'Triangle',label:'Triangle'},    {value:'Trombone',label:'Trombone'},    {value:'Trombonium',label:'Trombonium'},    {value:'Trumpet',label:'Trumpet'},    {value:'Tuba',label:'Tuba'},    {value:'TubularBells',label:'Tubular Bells'},    {value:'Turntable',label:'Turntable'},    {value:'Udu',label:'Udu'},    {value:'UilleannPipes',label:'Uilleann Pipes'},    {value:'Ukulele',label:'Ukulele'},    {value:'UprightPiano',label:'Upright Piano'},    {value:'ValveTrombone',label:'Valve Trombone'},    {value:'Veena',label:'Veena'},    {value:'Vibraphone',label:'Vibraphone'},    {value:'Vibraslap',label:'Vibraslap'},    {value:'Vielle',label:'Vielle'},    {value:'Viol',label:'Viol'},    {value:'Viola',label:'Viola'},    {value:'ViolaD’Amore',label:'Viola D’Amore'},    {value:'ViolaDaGamba',label:'Viola Da Gamba'},    {value:'Violin',label:'Violin'},    {value:'Violoncello',label:'Violoncello'},    {value:'Violone',label:'Violone'},    {value:'Vocals',label:'Vocals'},    {value:'Vocoder',label:'Vocoder'},    {value:'Washboard',label:'Washboard'},    {value:'Whistle',label:'Whistle'},    {value:'WoodBlock',label:'Wood Block'},    {value:'WoodFlute',label:'Wood Flute'},    {value:'Wurlitzer',label:'Wurlitzer'},    {value:'Xylophone',label:'Xylophone'},    {value:'Zarb',label:'Zarb'},    {value:'Zithe',label:'Zithe'} ]

  //  const  roleOptions = [{ value: 'A&R Administrator',label: 'A&R Administrator'},{ value: 'A&R Manager',label: 'A&R Manager'},   { value: 'Actor',label: 'Actor'}, { value: 'Adapter',label: 'Adapter'},   { value: 'Agent',label: 'Agent'},   { value: 'Arranger',label: 'Arranger'},   { value: 'Art Direction',label: 'Art Direction'},   { value: 'Assistant Composer',label: 'Assistant Composer'},   { value: 'Assistant Conductor',label: 'Assistant Conductor'},   { value: 'Assistant Mastering Engineer',label: 'Assistant Mastering Engineer'},   { value: 'Assistant Mixing Engineer',label: 'Assistant Mixing Engineer'},   { value: 'Assistant Producer',label: 'Assistant Producer'},   { value: 'Assistant Recording Engineer',label: 'Assistant Recording Engineer'},   { value: 'Assistant Sound Engineer',label: 'Assistant Sound Engineer'},   { value: 'Author',label: 'Author'},   { value: 'Band',label: 'Band'},   { value: 'Camera Operator',label: 'Camera Operator'},   { value: 'Choir',label: 'Choir'},   { value: 'Choir Conductor',label: 'Choir Conductor'},   { value: 'Choreographer',label: 'Choreographer'},   { value: 'Chorus',label: 'Chorus'},   { value: 'Chorus Master',label: 'Chorus Master'},   { value: 'Cinemaphotographer',label: 'Cinemaphotographer'},   { value: 'Co-Producer',label: 'Co-Producer'},   { value: 'Composer',label: 'Composer'},{ value: 'Computer Graphic Creator',label: 'Computer Graphic Creator'},{ value: 'Conductor',label: 'Conductor'},   { value: 'Contributing Artist',label: 'Contributing Artist'},   { value: 'Costume Designer',label: 'Costume Designer'},    { value: 'Creative Director',label: 'Creative Director'},    { value: 'Dancer',label: 'Dancer'},     { value: 'Director',label: 'Director'},      { value: 'DJ',label: 'DJ'},       { value: 'Editor',label: 'Editor'},         { value: 'Engineer',label: 'Engineer'},            { value: 'Ensemble',label: 'Ensemble'},              { value: 'Executive Producer',label: 'Executive Producer'},
  //               { value: 'Featuring',label: 'Featuring'},   { value: 'Gaffer',label: 'Gaffer'},   { value: 'Guest Vocals',label: 'Guest Vocals'},   { value: 'Immersive Audio Engineer',label: 'Immersive Audio Engineer'},   { value: 'Immersive Mastering Engineer',label: 'Immersive Mastering Engineer'},   { value: 'Immersive Mixing Engineer',label: 'Immersive Mixing Engineer'},   { value: 'Key Grip',label: 'Key Grip'},   { value: 'Librettist',label: 'Librettist'},   { value: 'Lighting Director',label: 'Lighting Director'},   { value: 'Liner Notes',label: 'Liner Notes'},   { value: 'Lyricist',label: 'Lyricist'},   { value: 'Mastering Engineer',label: 'Mastering Engineer'},   { value: 'MC',label: 'MC'},   { value: 'Mixer',label: 'Mixer'},   {value: 'Mixing Engineer',label: 'Mixing Engineer'},   { value: 'Musical Director',label: 'Musical Director'},   { value: 'Narrator',label: 'Narrator'},   { value: 'Orchestra',label: 'Orchestra'},   { value: 'Orchestrator',label: 'Orchestrator'},   { value: 'Performer',label: 'Performer'},   { value: 'Playwright',label: 'Playwright'},   { value: 'Post-Producer',label: 'Post-Producer'},   { value: 'Producer',label: 'Producer'},   { value: 'Production Assistant',label: 'Production Assistant'},   { value: 'Programmer',label: 'Programmer'},   { value: 'Recording Engineer',label: 'Recording Engineer'},   { value: 'Remixer',label: 'Remixer'},{ value: 'Sampled Artist',label: 'Sampled Artist'},{ value: 'Set Designer',label: 'Set Designer'},{ value: 'Soloist',label: 'Soloist'},{ value: 'Sound Editor',label: 'Sound Editor'},{ value: 'Sound Engineer',label: 'Sound Engineer'},{ value: 'Spoken Word',label: 'Spoken Word'},{ value: 'Strings Conductor',label: 'Strings Conductor'},{ value: 'Studio Musician',label: 'Studio Musician'},{ value: 'Studio Personnel',label: 'Studio Personnel'},{ value: 'Tonmeister',label: 'Tonmeister'},{ value: 'Translator',label: 'Translator'},{ value: 'Video Director',label: 'Video Director'},{ value: 'Video Producer',label: 'Video Producer'},   { value: 'Visual Effects Technician',label: 'Visual Effects Technician'},{ value: 'Vocal Engineer',label: 'Vocal Engineer'},{ value: 'Vocal Producer',label: 'Vocal Producer'},{ value: 'Writer',label: 'Writer'}]
    
    const artistOptions = [{value:'2WEI', label:'2WEI'},{value:'a-JAE', label:'a-JAE'},{value:'A.mon', label:'A.mon'},{value:'aa', label:'aa'},{value:'Alvin Chea', label:'Alvin Chea'},{value:'Audrey Callahan', label:'Audrey Callahan'},{value:'B.LEM', label:'B.LEM'},{value:'BangEan Yang', label:'BangEan Yang'},{value:'Basick', label:'Basick'},{value:'BEN', label:'BEN'},{value:'Benjamin Botkin', label:'Benjamin Botkin'},{value:'Benjamin Wallfisch', label:'Benjamin Wallfisch'},{value:'Bill Brown', label:'Bill Brown'},{value:'BM', label:'BM'},{value:'Bokyung Kim', label:'Bokyung Kim'},{value:'Bona Kim', label:'Bona Kim'},{value:'BoySam', label:'BoySam'},{value:'Cedric Baravaglio', label:'Cedric Baravaglio'},{value:'Changbeom Kim', label:'Changbeom Kim'},{value:'CHIO CHICANO', label:'CHIO CHICANO'},{value:'Coke paris', label:'Coke paris'},{value:'Colin O\'Malley', label:'Colin O\'Malley'},{value:'Couch Peach', label:'Couch Peach'},{value:'Cris Velasco', label:'Cris Velasco'},{value:'Dalparan', label:'Dalparan'},{value:'DeVita', label:'DeVita'},{value:'DIOS', label:'DIOS'},{value:'Dongsuk Jeon', label:'Dongsuk Jeon'},{value:'Drake', label:'Drake'},{value:'Eurielle', label:'Eurielle'},{value:'Gareth Coker', label:'Gareth Coker'},{value:'Gen Neo', label:'Gen Neo'},{value:'Guus Dielissen', label:'Guus Dielissen'},{value:'HANA', label:'HANA'},{value:'Hangzoo', label:'Hangzoo'},{value:'Hideyuki Fukasawa', label:'Hideyuki Fukasawa'},{value:'	Hoony Hoon', label:'Hoony Hoon'},{value:'hu', label:'hu'},{value:'Inon Zur', label:'Inon Zur'},{value:'IWASHIRO TARO', label:'IWASHIRO TARO'},{value:'Izi', label:'Izi'},{value:'J. Bass', label:'J. Bass'},{value:'Jamie Christopherson', label:'Jamie Christopherson'},{value:'Jangwon Lee', label:'Jangwon Lee'},{value:'Jay Park', label:'Jay Park'},{value:'Jean-Gabriel Raynaud', label:'Jean-Gabriel Raynaud'},{value:'Jessi', label:'Jessi'},{value:'Jo hyun ah', label:'Jo hyun ah'},{value:'Joey Newman', label:'Joey Newman'},{value:'Johan Kim', label:'Johan Kim'},{value:'JohnSmithF', label:'JohnSmithF'},{value:'JOYjin', label:'JOYjin'},{value:'Julie Elven', label:'Julie Elven'},{value:'JUN. K', label:'JUN. K'},{value:'Jung Dong Ha', label:'Jung Dong Ha'},{value:'Junghwan Park', label:'Junghwan Park'},{value:'Justin Park', label:'Justin Park'},{value:'Kisum', label:'Kisum'},{value:'Koala', label:'Koala'},{value:'Krzysztof Wierzynkiewicz', label:'Krzysztof Wierzynkiewicz'},
    {value:'Krzysztof Wierzynkiewicz', label:'Krzysztof Wierzynkiewicz'},{value:'Layone', label:'Layone'},{value:'Lil Boi', label:'Lil Boi'},{value:'Little V.', label:'Little V.'},{value:'littlerick', label:'littlerick'},{value:'LMS', label:'LMS'},{value:'lofi', label:'lofi'},{value:'ManSuQ', label:'ManSuQ'},{value:'Marc Jungermann', label:'Marc Jungermann'},{value:'Max Cameron', label:'Max Cameron'},{value:'Michal Cielecki', label:'Michal Cielecki'},{value:'Microdot', label:'Microdot'},{value:'Mimi Page', label:'Mimi Page'},{value:'Miya', label:'Miya'},{value:'Muzie', label:'Muzie'},{value:'naco', label:'naco'},{value:'Nayeon Kim', label:'Nayeon Kim'},{value:'NCSOUND', label:'NCSOUND'},{value:'neil', label:'neil'},{value:'Or Kribos', label:'Or Kribos'},{value:'Origa', label:'Origa'},{value:'Park Kyung', label:'Park Kyung'},{value:'pH-1', label:'pH-1'},{value:'PURA', label:'PURA'},{value:'QUESTROSOUND', label:'QUESTROSOUND'},{value:'Robin Hoffmann', label:'Robin Hoffmann'},{value:'Saulius Petreikis', label:'Saulius Petreikis'},{value:'Sebastian Böhm', label:'Sebastian Böhm'},{value:'Slow Motion', label:'Slow Motion'},{value:'Soul Breeze', label:'Soul Breeze'},{value:'Soundhills', label:'Soundhills'},{value:'suho', label:'suho'},{value:'Sung Yubin', label:'Sung Yubin'},{value:'Sybrid', label:'Sybrid'},{value:'Synsnake', label:'Synsnake'}
  ]


  const publisherOptions = [{value:'1002212373684', label:'Seohakr'},{value:'9138226768', label:'Divafresh Music'},{value:'8379610646', label:'BRANDNEW MUSIC'},{value:'8375705886', label:'코알라 Koala'},{value:'7321946425', label:'BM Music Label'},{value:'7182431275', label:'N3RVE'},{value:'6816727862', label:'Koala'}]

  // const LanguageOptions = [{ value: 'Afar', label: 'Afar' },    { value: 'Abkhazian', label: 'Abkhazian' },    { value: 'Avestan', label: 'Avestan' },    { value: 'Afrikaans', label: 'Afrikaans' },    { value: 'Akan', label: 'Akan' },    { value: 'Amharic', label: 'Amharic' },    { value: 'Aragonese', label: 'Aragonese' },    { value: 'Arabic', label: 'Arabic' },    { value: 'Assamese', label: 'Assamese' },    { value: 'Avaric', label: 'Avaric' },    { value: 'Aymara', label: 'Aymara' },    { value: 'Azerbaijani', label: 'Azerbaijani' },    { value: 'Bashkir', label: 'Bashkir' },    { value: 'Belarusian', label: 'Belarusian' },    { value: 'Bulgarian', label: 'Bulgarian' },    { value: 'Bhojpuri', label: 'Bhojpuri' },    { value: 'Bislama', label: 'Bislama' },    { value: 'Bambara', label: 'Bambara' },    { value: 'Bengali', label: 'Bengali' },    { value: 'Tibetan', label: 'Tibetan' },    { value: 'Breton', label: 'Breton' },    { value: 'Bosnian', label: 'Bosnian' },    { value: 'Catalan', label: 'Catalan' },    { value: 'Chechen', label: 'Chechen' },    { value: 'Chamorro', label: 'Chamorro' },    { value: 'Chechen', label: 'Chechen' },    { value: 'Chinese (Simplified)', label: 'Chinese (Simplified)' },    { value: 'Chinese (Traditional)', label: 'Chinese (Traditional)' },    { value: 'Corsican', label: 'Corsican' },    { value: 'Creole, English based', label: 'Creole, English based' },    { value: 'Creole, French based', label: 'Creole, French based' },    { value: 'Creole, Portuguese based', label: 'Creole, Portuguese based' },    { value: 'Cree', label: 'Cree' },    { value: 'Czech', label: 'Czech' },    { value: 'Church Slavic', label: 'Church Slavic' },    { value: 'Chuvash', label: 'Chuvash' },    { value: 'Welsh', label: 'Welsh' },    { value: 'Danish', label: 'Danish' },    { value: 'German', label: 'German' },    { value: 'Divehi', label: 'Divehi' },    { value: 'Dzongkha', label: 'Dzongkha' },    { value: 'Ewe', label: 'Ewe' },    { value: 'Greek', label: 'Greek' },    { value: 'English', label: 'English' },    { value: 'Esperanto', label: 'Esperanto' },    { value: 'Spanish', label: 'Spanish' },    { value: 'Spanish (Latin America)', label: 'Spanish (Latin America)' },    { value: 'Estonian', label: 'Estonian' },    { value: 'Basque', label: 'Basque' },    { value: 'Persian', label: 'Persian' },    { value: 'Fulah', label: 'Fulah' },    { value: 'Finnish', label: 'Finnish' },    { value: 'Fijian', label: 'Fijian' },
  //   { value: 'Faroese', label: 'Faroese' },    { value: 'French', label: 'French' },    { value: 'Western Frisian', label: 'Western Frisian' },    { value: 'Irish', label: 'Irish' },    { value: 'Gaelic', label: 'Gaelic' },    { value: 'Galician', label: 'Galician' },    { value: 'Guarani', label: 'Guarani' },    { value: 'Gujarati', label: 'Gujarati' },    { value: 'Manx', label: 'Manx' },    { value: 'Hausa', label: 'Hausa' },    { value: 'Haitian Creole', label: 'Haitian Creole' },    { value: 'Hebrew', label: 'Hebrew' },{ value: 'Hindi', label: 'Hindi' },{ value: 'Hiri Motu', label: 'Hiri Motu' },    { value: 'Croatian', label: 'Croatian' },    { value: 'Haitian', label: 'Haitian' },    { value: 'Hungarian', label: 'Hungarian' },    { value: 'Armenian', label: 'Armenian' },    { value: 'Herero', label: 'Herero' },    { value: 'Interlingua', label: 'Interlingua' },    { value: 'Indonesian', label: 'Indonesian' },    { value: 'Interlingue', label: 'Interlingue' },    { value: 'Igbo', label: 'Igbo' },    { value: 'Sichuan Yi', label: 'Sichuan Yi' },{ value: 'Inupiaq', label: 'Inupiaq' },    { value: 'Ido', label: 'Ido' },    { value: 'Icelandic', label: 'Icelandic' },    { value: 'Italian', label: 'Italian' },    { value: 'Inuktitut', label: 'Inuktitut' },    { value: 'Japanese', label: 'Japanese' },    { value: 'Japanese Katakana', label: 'Japanese Katakana' },    { value: 'Japanese Roman', label: 'Japanese Roman' },{ value: 'Javanese', label: 'Javanese' },{ value: 'Georgian', label: 'Georgian' },{ value: 'Kongo', label: 'Kongo' },{ value: 'Kikuyu', label: 'Kikuyu' },    { value: 'Kuanyama', label: 'Kuanyama' },    { value: 'Kazakh', label: 'Kazakh' },    { value: 'Kalaallisut', label: 'Kalaallisut' },    { value: 'Kannada', label: 'Kannada' },    { value: 'Korean', label: 'Korean' },{ value: 'Kanuri', label: 'Kanuri' },    { value: 'Kashmiri', label: 'Kashmiri' },    { value: 'Kurdish', label: 'Kurdish' },    { value: 'Komi', label: 'Komi' },    { value: 'Cornish', label: 'Cornish' },    { value: 'Kirghiz', label: 'Kirghiz' },    { value: 'Latin', label: 'Latin' },    { value: 'Luxembourgish', label: 'Luxembourgish' },    { value: 'Luganda', label: 'Luganda' },    { value: 'Limburgan', label: 'Limburgan' },    { value: 'Lingala', label: 'Lingala' },{ value: 'Lao', label: 'Lao' },{ value: 'Lithuanian', label: 'Lithuanian' },    { value: 'Luba-Katanga', label: 'Luba-Katanga' },    { value: 'Latvian', label: 'Latvian' },
  //   { value: 'Malagasy', label: 'Malagasy' },    { value: 'Magahi', label: 'Magahi' },    { value: 'Maithili', label: 'Maithili' },    { value: 'Marshallese', label: 'Marshallese' },{ value: 'Maori', label: 'Maori' },{ value: 'Macedonian', label: 'Macedonian' },    { value: 'Malayalam', label: 'Malayalam' },    { value: 'Mongolian', label: 'Mongolian' },{ value: 'Marathi', label: 'Marathi' },{ value: 'Malay', label: 'Malay' },{ value: 'Maltese', label: 'Maltese' },{ value: 'Burmese', label: 'Burmese' },{ value: 'Nauru', label: 'Nauru' },{ value: 'Norwegian Bokmål', label: 'Norwegian Bokmål' },{ value: 'North Ndebele', label: 'North Ndebele' },{ value: 'Nepali', label: 'Nepali' },{ value: 'Ndonga', label: 'Ndonga' },{ value: 'Dutch', label: 'Dutch' },{ value: 'Norwegian Nynorsk', label: 'Norwegian Nynorsk' },{ value: 'Norwegian', label: 'Norwegian' },{ value: 'South Ndebele', label: 'South Ndebele' },{ value: 'Navajo', label: 'Navajo' },    { value: 'Chichewa', label: 'Chichewa' },{ value: 'Occitan', label: 'Occitan' },{ value: 'Ojibwa', label: 'Ojibwa' },{ value: 'Oromo', label: 'Oromo' },{ value: 'Oriya', label: 'Oriya' },{ value: 'Ossetian', label: 'Ossetian' },{ value: 'Punjabi', label: 'Punjabi' },{ value: 'Pali', label: 'Pali' },{ value: 'Polish', label: 'Polish' },{ value: 'Pushto', label: 'Pushto' },    { value: 'Portuguese', label: 'Portuguese' },   { value: 'Quechua', label: 'Quechua' },    { value: 'Romansh', label: 'Romansh' },    { value: 'Rundi', label: 'Rundi' },    { value: 'Romanian', label: 'Romanian' },{ value: 'Russian', label: 'Russian' },{ value: 'Kinyarwanda', label: 'Kinyarwanda' },    { value: 'Sanskrit', label: 'Sanskrit' },    { value: 'Sardinian', label: 'Sardinian' },    { value: 'Sindhi', label: 'Sindhi' },{ value: 'Northern Sami', label: 'Northern Sami' },{ value: 'Sango', label: 'Sango' },    { value: 'Sinhala', label: 'Sinhala' },    { value: 'Slovak', label: 'Slovak' },    { value: 'Slovene', label: 'Slovene' },    { value: 'Samoan', label: 'Samoan' },    { value: 'Shona', label: 'Shona' },    { value: 'Somali', label: 'Somali' },    { value: 'Serbian', label: 'Serbian' },    { value: 'Swati', label: 'Swati' },    { value: 'Sotho, Southern', label: 'Sotho, Southern' },    { value: 'Sundanese', label: 'Sundanese' },    { value: 'Swedish', label: 'Swedish' },    { value: 'Swahili', label: 'Swahili' },    { value: 'Tamil', label: 'Tamil' },   { value: 'Telugu', label: 'Telugu' },    { value: 'Tajik', label: 'Tajik' },
  //   { value: 'Thai', label: 'Thai' },    { value: 'Tigrinya', label: 'Tigrinya' },    { value: 'Turkmen', label: 'Turkmen' },    { value: 'Tagalog', label: 'Tagalog' },    { value: 'Tswana', label: 'Tswana' },{ value: 'Tonga (Tonga Islands)', label: 'Tonga (Tonga Islands)' },    { value: 'Turkish', label: 'Turkish' },    { value: 'Tsonga', label: 'Tsonga' },    { value: 'Tatar', label: 'Tatar' },    { value: 'Twi', label: 'Twi' },    { value: 'Tahitian', label: 'Tahitian' },    { value: 'Uighur', label: 'Uighur' },    { value: 'Ukrainian', label: 'Ukrainian' },    { value: 'Urdu', label: 'Urdu' },    { value: 'Uzbek', label: 'Uzbek' },    { value: 'Venda', label: 'Venda' },{ value: 'Vietnamese', label: 'Vietnamese' },    { value: 'Volapük', label: 'Volapük' },    { value: 'Walloon', label: 'Walloon' },    { value: 'Wolof', label: 'Wolof' },    { value: 'Xhosa', label: 'Xhosa' },    { value: 'Yiddish', label: 'Yiddish' },    { value: 'Cantonese', label: 'Cantonese' },{ value: 'Yoruba', label: 'Yoruba' },    { value: 'Zhuang', label: 'Zhuang' },    { value: 'Chinese', label: 'Chinese' },    { value: 'Zulu', label: 'Zulu' }    ]

  const ExplicitContentOptions = [{ value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }]

    function closeDeletePopup(){
        setDeletePopup(false)
      }
  

  const changeContributorHandler = value => {
    setContributor(value)
    }

   const changePublisherHandler = value => {
        setPublisher(value)
        }

   const changeComposerHandler = value => {
            setComposer(value)
        }

    const changeLanguageHandler = value => {
            setAudioLanguage(value)
            setUnsavedChanges(true);
      }

      const changeMetaLanguageHandler = value => {
        setTrackMetadataLanguage(value)
        setUnsavedChanges(true);
      }

      const changeExplicitHandler = value => {
        setExplicitContent(value)
        setUnsavedChanges(true);
      }


  /** Add Artist, Pubnblisher or roles */

  /** Role Operations */

   const changeRoleHandler = value => {
    setRole(value)
    var temp = []


    artistRoles.map((role)=>{
      temp.push(role)
    })

    temp.push(value)
    console.log("dddddddddddddddddd")
    console.log(temp)
    setArtistRoles(temp)
    setRoleToggle(false)
  }


  const deleterole = (index) =>{
    var temp=[...artistRoles]

    temp = temp.filter((val,ind)=>ind!==index)

    setArtistRoles(temp)

  }


  /** Instrument Operations */

  const changeInstrumentHandler = value => {
      setInstruments(value)
      var temp = []

      artistInstuments.map((inst)=>{
        temp.push(inst)
      })

      temp.push(value)

      setArtistInstruments(temp)
      setInstumentToggle(false)
  }

  
  const deleteInstrument = (index) =>{
    var temp=[...artistInstuments]

    temp = temp.filter((val,ind)=>ind!==index)

    setArtistInstruments(temp)

  }


  /** Contributor Operations */

  const addContributor = () =>{
    var temp = []
    const arr= [...trackContributors]

    arr.map((tackcontributor)=>{
      temp.push(tackcontributor)
    })


    temp.push({name:contributor.label,id:contributor.value,roles:artistRoles,instruments:artistInstuments,editbox:false})
    
    setTrackContributors(temp)
    setUnsavedChanges(true);
  }

  const editContributor = (selected) =>{
    var temp = []
    const arr= [...trackContributors]

    arr.map((tackcontributor,index)=>{
      if(index !== selected){
        temp.push(tackcontributor)
      }

      if(index === selected){
        temp.push({name:contributor.label,id:contributor.value,roles:artistRoles,instruments:artistInstuments,editbox:false})
      }
     
    })

    setTrackContributors(temp)
    setUnsavedChanges(true);
  }

  const toggleContributorEdit = (select,val) =>{
    var temp = []
    const arr= [...trackContributors]

    arr.map((trackcontributor,index)=>{
      if(index!==select){
        temp.push(trackcontributor)
      }
      if(index===select){
        temp.push({name:trackcontributor.name,id:trackcontributor.id,roles:trackcontributor.roles,instruments:trackcontributor.instruments,editbox:val})
      }
    })

    setTrackContributors(temp)
  }

  const DeleteContributor = (select) =>{
    var temp = []
    const arr= [...trackContributors]

    temp =arr.filter((val,ind)=>ind!==select)
    
    setTrackContributors(temp)
    setUnsavedChanges(true);
  }

  /** Publisher Operations */

  const addPublisher = () =>{
    var temp = []

    trackPublishers.map((publisher)=>{
      temp.push(publisher)
    })

    temp.push({name:publishers.label,publisherid:publishers.value,composer:composer.label,composerid:composer.value,editbox:false})

    setTrackPublishers(temp)
    setUnsavedChanges(true);
  }

  const editPublisher = (selected) =>{
    var temp = []

    const arr= [...trackPublishers]

    arr.map((trackpublisher,index)=>{
      if(index!==selected){
        temp.push(trackpublisher)
      }
      if(index===selected){
        temp.push({name:publishers.label,publisherid:publishers.value,composer:composer.label,composerid:composer.value,editbox:false})
      }
    })

    console.log(temp)

    setTrackPublishers(temp)
    setUnsavedChanges(true);
  }


  const togglePublisherEdit = (select,val) =>{
    var temp = []

    const arr= [...trackPublishers]

    arr.map((trackpublisher,index)=>{
      if(index!==select){
        temp.push(trackpublisher)
      }
      if(index===select){
        temp.push({name:trackpublisher.name,publisherid:publishers.publisherid,composer:trackpublisher.composer,composerid:trackpublisher.composerid,editbox:val})
      }
    })

    setTrackPublishers(temp)
  }


  const DeletePublisher = (select) =>{
    var temp = []
    const arr= [...trackPublishers]

    temp =arr.filter((val,ind)=>ind!==select)
    
    setTrackPublishers(temp)
    setUnsavedChanges(true);
  }

  function closeUnsavedChangesPopup(){
    setUnsavedChangesPopup(false)
  }

  

  /** Artist Operations */

  const changeArtistHandler = value => {
    setTrackArtist(value)
    var temp=[]
    const save= [...trackartists]

    save.map((art)=>{
      temp.push(art)
    })


    temp.push({name:value.label,id:value.value,isFeatured:false})
    console.log("RRRRRRRRRRRRRRR")
    console.log(temp)
    setTrackArtists(temp)
   
    setArtistToggle(false)
    setUnsavedChanges(true);
  }

  

  

 

    {/** Drag drop funtions */}
    const handleDrag = (e) =>{
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
          } else if (e.type === "dragleave") {
            setDragActive(false);
          }
    }

    const onAddTrackClick = () => {
        addRef.current.click();
    };

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }


      const deleteArtist = (index) =>{
        var temp=[...trackartists]
  
        temp = temp.filter((val,ind)=>ind!==index)
  
        if(index===0){
          primaryChecked = false
        }
  
        if(index===1){
          featured1Checked = false
        }
  
        if(index===2){
          featured2Checked = false
        }
  
        if(index===3){
          featured3Checked = false
        }
  
        if(index===4){
          featured4Checked = false
        }
  
        if(index===5){
          featured5Checked = false
        }
        if(index===6){
          featured6Checked = false
        }
  
        setTrackArtists(temp)
        setUnsavedChanges(true);
      }

    useEffect(()=>{
      getInstruments()
      getLanguageOptions()
      getRoleOptions()
      getLabelId("neil")
      getArtistList()
      setCheckAssetArr(Math.random())
     

      // const fetchFugaIds = async () => {
      //   const fugaIds = await getFugaIdsPart(1); // Call with appropriate offset
      //   console.log("TTTTTTTTTTTTTTTTTTTTTTTTT"); // Log the result
      //   console.log(fugaIds); // Log the result
      // };

      // fetchFugaIds()

      if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
        setPagePath("/Dashboard/releasemusic/trackdetails")
      }
  
      if(decodeToken(cookies.get('token')).info.role==="label"){
        setPagePath("/dashboard/label/releasemusic/trackdetails")
      }
    },[])

    {/*Enable next btn when all track details entered*/}
    useEffect(()=>{
        setNextBtn(true)
          files.map((file,index)=>{
            if(file.Tracktitle.length===0 || file.Arists.length===0){
              console.log("BOMBMB")
              setNextBtn(false)
            }
          })
      },[checkAssetArr])

      useEffect(()=>{
        console.log(trackContributors)
      },[trackContributors])
    
      useEffect(()=>{
        console.log("Publishers changed")
        console.log(trackPublishers)
      },[trackPublishers])

      useEffect(()=>{
        if(trackContributors[contributorId]!==undefined && editContributorPopup){
          setContributor({value:trackContributors[contributorId].id, label:trackContributors[contributorId].name})
          setArtistRoles(trackContributors[contributorId].roles)
          setArtistInstruments(trackContributors[contributorId].instruments)
        }
         
      },[editContributorPopup]) 


      useEffect(()=>{

      },[trackartists])
  
  
      useEffect(()=>{
        if(trackPublishers[publisherId]!==undefined && editPublisherPopup){
          setPublisher({value:trackPublishers[publisherId].publisherid, label:trackPublishers[publisherId].name})
          setComposer({value:trackPublishers[publisherId].composerid, label:trackPublishers[publisherId].composer})
        }
         
      },[editPublisherPopup])

      /**TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT */
    {/*Fired when track detailts popup opens initializes saved values*/}
    useEffect(()=>{
      console.log("In tehejkds")
      if(popupstate==="From track details"){

        if(files[popupId]!==undefined && trackPopup){
          if(files[popupId].Tracktitle.length!==0){
            setTrackname(files[popupId].Tracktitle)
          }
          if(files[popupId].Arists.length===0){
            setArtistToggle(true)
            setTrackArtists([{name:artistName,isFeatured:false}])
          }
        }
  
        if(files[popupId]!==undefined && trackPopup){
          if(files[popupId].Arists.length!==0){
            setTrackArtists(files[popupId].Arists)
          }
        }
  
        if(files[popupId]!==undefined && trackPopup){
          if(files[popupId].Contributors.length!==0){
            setTrackContributors(files[popupId].Contributors) 
          }
        }
  
        if(files[popupId]!==undefined && trackPopup){
          if(files[popupId].Publishers.length!==0){
            setTrackPublishers(files[popupId].Publishers) 
          }
        }
  
        if(files[popupId]!==undefined && trackPopup){
          if(files[popupId].Lyrics.length!==0){
            setLyrics(files[popupId].Lyrics) 
            setLyricsClass("LyricsModuleOpen")
          }
        }
  
        if(files[popupId]!==undefined && trackPopup){
          if(files[popupId].AudioLanguage.length!==0){
             setAudioLanguage({'value':files[popupId].AudioLanguage.value,'label':files[popupId].AudioLanguage.label})
             setAdvanceTrackFields(true);
             setTrackLanguageClass("TrackLanguageModuleOpen")
            }
             if(files[popupId].MetadataLanguage.length!==0){
              setTrackMetadataLanguage({'value':files[popupId].MetadataLanguage.value,'label':files[popupId].MetadataLanguage.label})
            }
  
             if(files[popupId].ExplicitContent.length!==0){
              setExplicitContent({'value':files[popupId].ExplicitContent,'label':files[popupId].ExplicitContent})
            }  
        }

      }
      

      
    },[trackPopup])

    useEffect(()=>{
      console.log(lyrics)
    },[lyrics])

    const getInstruments = ()=>{
        axios({
          method:'get',
          url:"https://n3rve.fly.dev/metadata/instruments",
          headers:{
              Authorization: "Bearer ".concat(cookies.get("token"))
          }
      }).then((response)=>{
        if(response.status===200){
          var instruments = []
          response.data.map((option)=>{
            instruments.push({ value: option.id, label: option.name })
          })
          setInstOptions(instruments)
        }
      }).catch(function (e){
        console.log(e.response)
      })   
    }

    const getLanguageOptions = () =>{
      axios({
        method:'get',
        url:"https://n3rve.fly.dev/metadata/audio_locales",
        headers:{
            Authorization: "Bearer ".concat(cookies.get("token"))
        }
    }).then((response)=>{
      if(response.status===200){
        var langs= []
        console.log("This is the lang popup")
        console.log(response.data)
        response.data.map((option)=>{
          langs.push({ value: option.id, label: option.name })
        })
        setLangOptions(langs)
      }
    }).catch(function (e){
      console.log(e.response)
    })    
    }

    const getRoleOptions = () =>{
      axios({
        method:'get',
        url:"https://n3rve.fly.dev/metadata/contributor_roles",
        headers:{
            Authorization: "Bearer ".concat(cookies.get("token"))
        }
    }).then((response)=>{
      if(response.status===200){
        var roles= []
        response.data.map((option)=>{
          roles.push({ value: option.id, label: option.name })
        })
        setRoleOptions(roles)
      }
    }).catch(function (e){
      console.log(e.response)
    })    
    }

    const getFugaIds = () =>{
        var TotalFugaIds =[]

        const fetchFugaIds = async () => {
          const fugaIds = await getFugaIdsPart(fugaIdTimes); // Call with appropriate offset
          console.log("TTTTTTTTTTTTTTTTTTTTTTTTT"); // Log the result
          console.log(fugaIds); // Log the result
        };

        fetchFugaIds()
    }

    useEffect(()=>{
      console.log(lyrics)
      var TotalFugaIds =[]
      
      for(var i=0;i<=fugaIdTimes;i++){

        const fetchFugaIds = async () => {
          const fugaIds = await getFugaIdsPart(i); // Call with appropriate offset
          TotalFugaIds.push(...fugaIds)
        };

        fetchFugaIds()
       
      }
 
      // console.log("YYYYYYYYYYYYYYYYYYYYYYYYYYY")
      // console.log(TotalFugaIds)
      // TotalFugaIds.map((fid)=>{
      //   console.log(fid)
      // })
      setFugaArtistIds(TotalFugaIds)
    },[fugaIdTimes])


    useEffect(()=>{
      console.log("TOOOOOOOOOOOOOOOOOOOOOO")
      console.log(fugaArtistId)
    },[fugaArtistId])

    // const getFugaIdsPart = async (offset) =>{
    //   // var fugaids= []
    //   axios({
    //     method:'get',
    //     url:"https://n3rve.fly.dev/artists?name=&page=".concat(offset),
    //     headers:{
    //         Authorization: "Bearer ".concat(cookies.get("token"))
    //     }
    // }).then((response)=>{
    //   if(response.status===200 && response.data.artist){
    //     const fugaids = response.data.artist.map((option) => ({
    //       value: option.id,
    //       label: option.name
    //     }));
    //     // response.data.artist.map((option)=>{
    //     //   fugaids.push({ value: option.id, label: option.name })
    //     // })
    //     console.log(Math.floor(response.data.total/response.data.page_size))
    //     console.log(fugaids)

    //     return fugaids; 
    //   }else{
    //     console.log("No data available or response not as expected");
    //     return []; // Return an empty array if no artist data is found
    //   }
    // }).catch(function (e){
    //   console.log(e.response)
    //   return []; // Return an empty array in case of error
    // })    
    // }


    const getFugaIdsPart = async (offset) => {
      try {
        const response = await axios({
          method: 'get',
          url: `https://n3rve.fly.dev/artists?name=&page=${offset}`,
          headers: {
            Authorization: `Bearer ${cookies.get("token")}`
          }
        });
    
        if (response.status === 200 && response.data.artist) {
          const fugaids = response.data.artist.map((option) => ({
            value: option.id,
            label: option.name
          }));
          
          console.log(Math.floor(response.data.total / response.data.page_size));
          console.log(fugaids);
         
          setFugaIdTimes(Math.floor(response.data.total / response.data.page_size))
          
    
          return fugaids; // Ensure we return fugaids even if the array is empty
        } else {
          console.log("No data available or response not as expected");
          return []; // Return an empty array if no artist data is found
        }
      } catch (e) {
        console.log(e.response);
        return []; // Return an empty array on error
      }
    };


    useEffect(()=>{
     
      var TotalFugaPersonIds =[]
      
      for(var i=0;i<=fugaIdTimes;i++){

        const fetchFugaIds = async () => {
          const fugaIds = await getFugaPersonIdsPart(i); // Call with appropriate offset
          TotalFugaPersonIds.push(...fugaIds)
        };

        fetchFugaIds()
       
      }
 
      // console.log("YYYYYYYYYYYYYYYYYYYYYYYYYYY")
      // console.log(TotalFugaIds)
      // TotalFugaIds.map((fid)=>{
      //   console.log(fid)
      // })
      setFugaPersonIds(TotalFugaPersonIds)
    },[fugaPersonIdTimes])

    useEffect(()=>{
      console.log("BOOOOOOOOOOOOOOOOOOOOOO")
      console.log(fugaPersonId)
    },[fugaPersonId])


    const getFugaPersonIdsPart = async (offset) => {
      try {
        const response = await axios({
          method: 'get',
          url: `https://n3rve.fly.dev/metadata/people?name=&page=${offset}`,
          headers: {
            Authorization: `Bearer ${cookies.get("token")}`
          }
        });
    
        if (response.status === 200 && response.data.person) {
          const fugapersonids = response.data.person.map((option) => ({
            value: option.id,
            label: option.name
          }));
          
          console.log(Math.floor(response.data.total / response.data.page_size));
          console.log(fugapersonids);
         
          setFugaPersonIdTimes(Math.floor(response.data.total / response.data.page_size))
          
    
          return fugapersonids; // Ensure we return fugaids even if the array is empty
        } else {
          console.log("No data available or response not as expected");
          return []; // Return an empty array if no artist data is found
        }
      } catch (e) {
        console.log(e.response);
        return []; // Return an empty array on error
      }
    };
    

    {/*get Artist Id*/} 
    const getArtistId = async (name) =>{
      return await axios.get("https://n3rve.fly.dev/artists?name=".concat(name))  
    }

    const getArtistList = () =>{
      axios({
        method:'get',
        url:"https://n3rve.fly.dev/artists?name=",
        headers:{
            Authorization: "Bearer ".concat(cookies.get("token"))
        }
        }).then((response)=>{
          if(response.status===200){
            var artists= []
            console.log(response)
          }
        }).catch(function (e){
          console.log(e.response)
        }) 
    }

    {/*get Label Id*/} 

    // const getLabelId = (data) =>{
    //   axios({
    //     method:'get',
    //     url:"https://n3rve.fly.dev/metadata/people?name=".concat(data),
    //     headers:{
    //         Authorization: "Bearer ".concat(cookies.get("token"))
    //     }
    // }).then((response)=>{
    //   if(response.status===200){
    //     console.log(response.data.person[0].id)
  
    //   }
    // }).catch(function (e){
    //   console.log(e.response)
    // })    
    // }

    const getLabelId = async (data) =>{
      return await axios.get("https://n3rve.fly.dev/metadata/people?name=".concat(data),
      {headers:{'Authorization': "Bearer ".concat(cookies.get("token"))}}
      )  
    }



    const handleAdd = (e) => {
        e.preventDefault();
        console.log("Fired")
          const filelist = files
          console.log(filelist)
          for(var i=0;i<e.target.files.length;i++){
            // filelist.push(e.target.files[i])
            if(e.target.files[i].type==="audio/mpeg" || e.target.files[i].type==="audio/wav"){
          //   filelist.push({
          //     "Asset_id":null,
          //     "Trackname":"",
          //     "Asset_file":e.target.files[i],
          //     "Producers":[],
          //     "ProducerIds":[],
          //     "Songwriters":[],
          //     "SongwriterIds":[],
          //      "FeaturedArtist":[],
          //     "FeaturedArtistIds":[],
          //       "ExplicitContent":"",
          //       "Price":0.99,
          //       "Language":"",
          //       "RadioEdit":"",
          //       "Collaborators":[],
          //       "CollaboratorIds":[],
          //       "IsCollaborator":false,
          //       "isDragging":false,
          //       "isPlaying":false
          // })
          filelist.push({
            "Asset_id":null,
            "Tracktitle":"",
            "Asset_file":e.target.files[i],
            "Arists":[],
            "ArtistIds":[],
            "Contributors":[],
            "ContributorIds":[],
            "Publishers":[],
            "PublisherIds":[],
            "Lyrics":"",
            "AudioLanguage":"",
            "MetadataLanguage":"",
            "ExplicitContent":"",
            "Collaborators":[],
            "CollaboratorIds":[],
            "IsCollaborator":false,
            "isDragging":false,
            "isPlaying":false
        })
        }
          }
          console.log(filelist)
          setFiles(filelist)
          setUpdateFileList(Math.random())
          console.log(files)
    };

    const handleAppDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          var filelist=files
          for(var i=0;i<e.dataTransfer.files.length;i++){
            // filelist.push(e.dataTransfer.files[i])
            if(e.dataTransfer.files[i].type==="audio/mpeg" || e.dataTransfer.files[i].type==="audio/wav"){
            //  filelist.push({
            //     "Asset_id":null,
            //     "Trackname":"",
            //     "Asset_file":e.dataTransfer.files[i],
            //     "Producers":[],
            //     "ProducerIds":[],
            //     "Songwriters":[],
            //     "SongwriterIds":[],
            //     "FeaturedArtist":[],
            //     "FeaturedArtistIds":[],
            //     "ExplicitContent":"",
            //     "Price":0.99,
            //     "Language":"",
            //     "RadioEdit":"",
            //     "Collaborators":[],
            //     "CollaboratorIds":[],
            //     "IsCollaborator":false,
            //     "isDragging":false,
            //     "isPlaying":false
            // })
            filelist.push({
              "Asset_id":null,
              "Tracktitle":"",
              "Asset_file":e.dataTransfer.files[i],
              "Arists":[],
              "ArtistIds":[],
              "Contributors":[],
              "ContributorIds":[],
              "Publishers":[],
              "PublisherIds":[],
              "Lyrics":"",
              "AudioLanguage":"",
              "MetadataLanguage":"",
              "ExplicitContent":"",
              "Collaborators":[],
              "CollaboratorIds":[],
              "IsCollaborator":false,
              "isDragging":false,
              "isPlaying":false
          })
           }
          }
          setFiles(filelist)
          setUpdateFileList(Math.random())
        }
    };

    const handleSubmitTrackDetails = () =>{

        if(Trackname.length!==0){
          files[popupId].Tracktitle = Trackname
        }
        
        if(lyrics.length!==0){
          files[popupId].Lyrics = lyrics
        }
    
        files[popupId].AudioLanguage = AudioLanguage
    
        if(trackMetadatLanguage.length!==0){
          files[popupId].MetadataLanguage = trackMetadatLanguage
        }
    
        if(explicitContent.length!==0){
          files[popupId].ExplicitContent = explicitContent.value  
        }
    
        if(trackartists.length!==0){
          files[popupId].Arists = trackartists
        }
    
        if(trackContributors.length!==0){
          files[popupId].Contributors = trackContributors
        }
    
        if(trackPublishers.length!==0){
          files[popupId].Publishers = trackPublishers
        }

        setContributorIds([])
        if(trackContributors.length!==0){
          trackContributors.map((trackcontributor)=>{
            getLabelId(trackcontributor.name).then((res)=>{
              if(res.data.person.length!==0){
              setContributorIds((prevstate)=>[...prevstate,res.data.person[0].id]);
              }
            }) 
          })
        }

        setArtistIds([])
        if(trackartists.length!==0){
          trackartists.map((trackartist)=>{
            getArtistId(trackartist.name).then((res)=>{
              if(res.data.artist.length!==0){
              setArtistIds((prevstate)=>[...prevstate,res.data.artist[0].id]);
              }
            }) 
          })
        }

        setPublisherIds([])
        if(trackPublishers.length!==0){
          trackPublishers.map((trackpublisher)=>{
            getLabelId(trackpublisher.composer).then((res)=>{
              if(res.data.person.length!==0){
                setPublisherIds((prevstate)=>[...prevstate,res.data.person[0].id]);
              }
            
            }) 
          })
        }
    
        console.log("In handle submit")
        console.log(files[popupId])
    
      }

      useEffect(()=>{
        if(files[popupId]!==undefined){
          if(files[popupId].ArtistIds!==undefined){
            files[popupId].ArtistIds = artistIds
          }
          console.log("AAAAAAAAAAAAAAAAAAAAAAA")
          console.log(popupId)
          console.log(artistIds)
        }
       
      },[artistIds])

      useEffect(()=>{
        if(files[popupId]!==undefined){
          if(files[popupId].ContributorIds!==undefined){
            files[popupId].ContributorIds = contributorIds
          }
          console.log("CCCCCCCCCCCCCCCCCCCCCCC")
          console.log(popupId)
          console.log(contributorIds)
        }
      },[contributorIds])

      useEffect(()=>{
        if(files[popupId]!==undefined){
          if(files[popupId].PublisherIds!==undefined){
            files[popupId].PublisherIds = publisherIds
          }
          console.log("PPPPPPPPPPPPPPPPPPPPP")
          console.log(popupId)
          console.log(publisherIds)
        }
      },[publisherIds])


      useEffect(()=>{
        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX")
        console.log(files)
        // if(files.length===0){
        //   setTrackUploaded(false)
        // }
      },[files])

      useEffect(()=>{
        if(!trackUploaded){
          navigate("/Dashboard/releasemusic/uploadtracks")
        }
      },[trackUploaded])
    
    function D_Start(e,index){
        TrackItemDrag.current = index
        console.log("original pos")
        console.log(index)
      } 
    
      function D_Enter(e,index){
        TrackItemDragOver.current = index
    
        const trackdets = [...files]
    
        let finalArr = []
    
        trackdets.forEach(item=>{
          finalArr.push({
                "file":item.file,
                // "Asset_id":item.Asset_id,
                // "Trackname":item.Trackname,
                // "Asset_file":item.Asset_file,
                // "Producers":item.Producers,
                // "ProducerIds":item.ProducerIds,
                // "Songwriters":item.Songwriters,
                // "SongwriterIds":item.SongwriterIds,
                // "FeaturedArtist":item.FeaturedArtist,
                // "FeaturedArtistIds":item.FeaturedArtistIds,
                // "ExplicitContent":item.ExplicitContent,
                // "Price":item.Price,
                // "Language":item.Language,
                // "RadioEdit":item.RadioEdit,
                // "Collaborators":item.Collaborators,
                // "CollaboratorIds":item.CollaboratorIds,
                // "IsCollaborator":item.IsCollaborator,
                // "isDragging":false,
                // "isPlaying":item.isPlaying
                "Asset_id":item.Asset_id,
                "Tracktitle":item.Tracktitle,
                "Asset_file":item.Asset_file,
                "Arists":item.Arists,
                "ArtistIds":item.ArtistIds,
                "Contributors":item.Contributors,
                "ContributorIds":item.ContributorIds,
                "Publishers":item.Publishers,
                "PublisherIds":item.PublisherIds,
                "Lyrics":item.Lyrics,
                "AudioLanguage":item.AudioLanguage,
                "MetadataLanguage":item.MetadataLanguage,
                "ExplicitContent":item.ExplicitContent,
                "Collaborators":item.Collaborators,
                "CollaboratorIds":item.CollaboratorIds,
                "IsCollaborator":item.IsCollaborator,
                "isDragging":false,
                "isPlaying":item.isPlaying
          })
        })
        console.log("Entered")
        console.log(index)
    
        finalArr[index].isDragging = true;
        setFiles(finalArr)
      }
    
      function D_End(e,index){
          const arr = [...files]
          const track_item_main = arr[TrackItemDrag.current]
          arr.splice(TrackItemDrag.current, 1)
          arr.splice(TrackItemDragOver.current,0,track_item_main)
         
    
          TrackItemDrag.current = null;
          TrackItemDragOver.current = null;
    
          let finalArr = []
    
            arr.forEach(item=>{
              finalArr.push({
                    "file":item.file,
                    // "Asset_id":item.Asset_id,
                    // "Trackname":item.Trackname,
                    // "Asset_file":item.Asset_file,
                    // "Producers":item.Producers,
                    // "ProducerIds":item.ProducerIds,
                    // "Songwriters":item.Songwriters,
                    // "SongwriterIds":item.SongwriterIds,
                    // "FeaturedArtist":item.FeaturedArtist,
                    // "FeaturedArtistIds":item.FeaturedArtistIds,
                    // "ExplicitContent":item.ExplicitContent,
                    // "Price":item.Price,
                    // "Language":item.Language,
                    // "RadioEdit":item.RadioEdit,
                    // "Collaborators":item.Collaborators,
                    // "CollaboratorIds":item.CollaboratorIds,
                    // "IsCollaborator":item.IsCollaborator,
                    // "isDragging":false,
                    // "isPlaying":item.isPlaying
                "Asset_id":item.Asset_id,
                "Tracktitle":item.Tracktitle,
                "Asset_file":item.Asset_file,
                "Arists":item.Arists,
                "ArtistIds":item.ArtistIds,
                "Contributors":item.Contributors,
                "ContributorIds":item.ContributorIds,
                "Publishers":item.Publishers,
                "PublisherIds":item.PublisherIds,
                "Lyrics":item.Lyrics,
                "AudioLanguage":item.AudioLanguage,
                "MetadataLanguage":item.MetadataLanguage,
                "ExplicitContent":item.ExplicitContent,
                "Collaborators":item.Collaborators,
                "CollaboratorIds":item.CollaboratorIds,
                "IsCollaborator":item.IsCollaborator,
                "isDragging":false,
                "isPlaying":item.isPlaying
              })
            })
    
          setFiles(finalArr)
      }

      const hoverOverTrack = (index,value) =>{
        const hover= [...playstate]
        var change= []
        hover.forEach((item)=>{
            change.push(false)
          }
        )
        change[index]=value
        console.log(change)
        setPlayState(change)
      }

      const deletesong =  (songid) =>{
        setFiles(files.filter((file,index)=>{
          console.log("^^^^^^^^^^^")
          console.log(file)
          console.log(songid)
          console.log(index)
          return index!==songid
        })
        )
        setAudioLength(audiolength.filter((file,index)=>{
          return index!==songid
        }))
    }

      const TrackDetailsComplexStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '26.5em',
        height: '3em',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'1.2em',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
      menu:  styles => ({ ...styles, 
      color:'rgba(255, 255, 255, 1)',
      borderColor:'#636468',
      borderTopLeftRadius:'8px',
      borderTopRightRadius:'8px',
      marginTop:'-0em'
     }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)',
                                borderTopLeftRadius:'8px',
                                borderTopRightRadius:'8px',}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
         hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,16%)',
          }),
          menuList: (base) => ({
            ...base,
        
            "::-webkit-scrollbar": {
              width: "0px",
              height: "0px",
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1"
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888"
            },
            "::-webkit-scrollbar-thumb:hover": {
              background: "#555"
            }
          })
      };

      const TrackDetailsColourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '26.5em',
        height: '3em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'1.2em',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
         hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,16%)',
          })
      };
    
    return (
        <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
        <div className="AddMusicHeader">{t('Addtrackdetails')}</div>
  
       <div className="AddMusicDesc">{t('Completefieldsforeachtrack')}</div>

       <div className="AddMusicDesc" style={{color:'rgba(255,255,255,64%)',width:'53.81%',marginBottom:'0em',textAlign:'left'}}>Select a track</div>
       <div className="UploadContainer2">
        {
         files.map((file,index)=>{
           
             
             const id = "player".concat(index)
             
            
           //   const Audio = () => {
           //     const audioRef = useRef();
           
           //     const onLoadedMetadata = () => {
           //         if (audioRef.current) {
                       
                       
           //             setUpdateFileList(Math.random())
           //             // audiolength[index] = ("").concat(Math.floor(audioRef.current.duration / 60)).concat(":").concat(Math.floor(audioRef.current.duration - Math.floor(audioRef.current.duration / 60)*60).toFixed(0))
           //         }
           //     };
           //   {/* <source src={URL.createObjectURL(file)} type="audio/wav" /> */}
           //     return (
           //         <audio
           //             ref={audioRef}
           //             onLoadedMetadata={onLoadedMetadata}
           //             src={URL.createObjectURL(file)}
           //         />
                     
                   
           //     );
           // };

           return (
             <React.Fragment>
             <div draggable droppable
               onDragStart={e=>D_Start(e,index)}
               onDragEnter={e=>D_Enter(e,index)}
               onDragEnd={e=>D_End(e,index)}
               onMouseOver={()=>hoverOverTrack(index,true)}
               onMouseOut={()=>hoverOverTrack(index,false)}
               style={{backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.5em',justifyContent:'space-between',width:'81.81%',paddingTop:'1.09em',paddingBottom:'1.09em'}}> 
                   <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer'}} onClick={()=>{setPopupId(index);setPopupState("From track details");setTrackPopup(true)}}>
                       <img src={DragDots}  className={playstate[index] ?  'DragDotsVisible': 'DragDots'}/>
                       <div className="TrackNumber">
                         {index+1}.
                       </div>

                       {
                         (file.Tracktitle.length===0 || file.Arists.length===0)   &&  
                              <div style={{display:'flex',flexDirection:'column',justifyContent:'center',marginTop:'1.5em'}}>
                                {
                                  file.Tracktitle.length===0 &&
                                  <div className="TrackName" style={{textDecoration:'underline'}}>
                                  {file.Asset_file.name}
                                </div>
                                }

{
                                  file.Tracktitle.length!==0 &&
                                  <div className="TrackName" style={{textDecoration:'underline'}}>
                                  {file.Tracktitle}
                                </div>
                                }
                              
                              
                              {
                                
                                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginTop:'0.4em',marginLeft:'0.5em'}}>
                                 <img src={MissingTrackDetailsIcon} style={{width:'1em',height:'1em',marginRight:'0.4em'}}/>
                                <div className="TrackInfo" style={{color:'#FF8686',marginLeft:'0em'}}>
                                Missing track details. Must complete.
                                </div>
                               </div>
                              }

                             

                            {/* {
                                file.Songwriters[1] !== undefined && file.Songwriters[2] === undefined &&
                                <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="TrackInfo">
                                {file.Songwriters[0]},&nbsp;{file.Songwriters[1]}  &nbsp;/ &nbsp;{file.ExplicitContent} &nbsp;/ &nbsp;{file.Price}
                                </div>
                               </div>
                              } */}

{/* {
                                file.Songwriters[1] !== undefined && file.Songwriters[2] !== undefined &&
                                <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="TrackInfo">
                                {file.Songwriters[0]},&nbsp;{file.Songwriters[1]},&nbsp;{file.Songwriters[2]}  &nbsp;/ &nbsp;{file.ExplicitContent} &nbsp;/ &nbsp;{file.Price}
                                </div>
                               </div>
                              } */}
                           
                            </div>
                       }

                       {
                         file.Tracktitle.length!==0 && file.Arists.length!==0 &&
                         <div style={{display:'flex',flexDirection:'column',justifyContent:'center',marginTop:'1.5em'}}>
                           <div className="TrackName">
                             {file.Tracktitle}
                           </div>

                           <div  style={{display:'flex',flexDirection:'row',maxWidth:'30em',alignItems:'left',overflow:'hidden',marginLeft:'1.5em',flexShrink:'0'}}>
                              {
                               file.Arists.map((artist,index)=>{
                                 return (
                                   <div style={{display:'flex',flexDirection:'row',flexShrink:'0'}}>
                                   {
                                     (index===file.Arists.length-1) &&
                                     <div className="TrackInfo">
                                       {artist.name}/
                                     </div>
                                   }
                                 
                                   {
                                     (index>=0 && index!==file.Arists.length-1) &&
                                     <div className="TrackInfo">
                                      {artist.name},
                                     </div>
                                   }
                                   </div>
                                  
                                 )
                               })
                              }
                              {
                               file.Contributors.length!==0 &&
                               file.Contributors.map((contributor,index)=>{
                                 return (
                                   <div style={{display:'flex',flexDirection:'row',flexShrink:'0'}}>
                                     <div className="TrackInfo">
                                     &nbsp;{contributor.name},
                                     </div>
                                     <div className="TrackInfo">
                                     &nbsp;{contributor.roles[0].label},
                                     </div>
                                     {
                                       contributor.roles[1]!==undefined &&
                                       <div className="TrackInfo">
                                       &nbsp;{contributor.roles[1].label},
                                       </div>
                                     }
                                     {
                                       contributor.roles[2]!==undefined &&
                                       <div className="TrackInfo">
                                       &nbsp;{contributor.roles[2].label},
                                       </div>
                                     }
                                   </div>
                                 )
                               })
                              }
                               {
                               file.Publishers.length!==0 &&
                               file.Publishers.map((publisher,index)=>{
                                 return (
                                   <div style={{display:'flex',flexDirection:'row',flexShrink:'0'}}>
                                     <div className="TrackInfo">
                                     &nbsp;{publisher.name},
                                     </div>
                                     {

                                     }
                                     <div className="TrackInfo">
                                     &nbsp;{publisher.composer},
                                     </div>
                                   </div>
                                 )
                               })
                              }
                              {
                               file.Lyrics.length!==0 &&
                                   <div className="TrackInfo">
                                     &nbsp;{file.Lyrics},
                                     </div> 
                              }
                              </div>
                           
                           {/* {
                             file.Songwriters[1] === undefined &&
                             <div style={{display:'flex',flexDirection:'row'}}>
                             <div className="TrackInfo">
                             {file.Songwriters[0]} &nbsp;/ &nbsp;{file.ExplicitContent} &nbsp;/ &nbsp;{file.Price}
                             </div>
                            </div>
                           }

                         {
                             file.Songwriters[1] !== undefined && file.Songwriters[2] === undefined &&
                             <div style={{display:'flex',flexDirection:'row'}}>
                             <div className="TrackInfo">
                             {file.Songwriters[0]},&nbsp;{file.Songwriters[1]}  &nbsp;/ &nbsp;{file.ExplicitContent} &nbsp;/ &nbsp;{file.Price}
                             </div>
                            </div>
                           }

{
                             file.Songwriters[1] !== undefined && file.Songwriters[2] !== undefined &&
                             <div style={{display:'flex',flexDirection:'row'}}>
                             <div className="TrackInfo">
                             {file.Songwriters[0]},&nbsp;{file.Songwriters[1]},&nbsp;{file.Songwriters[2]}  &nbsp;/ &nbsp;{file.ExplicitContent} &nbsp;/ &nbsp;{file.Price}
                             </div>
                            </div>
                           } */}
                        
                         </div>
                       }
                      
                   </div>
                  
                  <div style={{display:'flex',flexDirection:'row'}}>
                     <div className="BtnContainer">
                     <AudioButton url={URL.createObjectURL(file.Asset_file)} />
                     </div>
                     {/* <audio src={URL.createObjectURL(file.Asset_file)}  id={id}/> */}
                     {/* <img src={PlayTrackIcon} className="TrackActionsIcon" onClick={()=>{ document.getElementById(id).play(); }} onDoubleClick={()=>{ document.getElementById(id).pause(); }}/> */}
                     {/* {
                       !playstate[index] &&
                       <img src={PlayTrackIcon} className="TrackActionsIcon" onClick={()=>{ document.getElementById(id).play();  playpause(index)}}/>
                     }

                     {
                       playstate[index] &&
                       <img src={PauseIcon} className="TrackActionsIcon" onClick={()=>{ document.getElementById(id).pause(); playpause(index)}}/>
                     } */}
                    
                     <img src={TrackFolderIcon} className="TrackActionsIcon" onClick={()=>fileref.current.click()}/>
                     <input ref={fileref} type="file" accept=".wav" style={{display:'none'}}/>
                     <img src={DeleteTrackIcon} className="TrackActionsIcon" onClick={()=>{setDeletePopup(true);setDeleteTrackIndex(index)}}/>
                  </div>
               
             </div>
             {
               file.isDragging &&
               <div className="drag-indicator"/>
             }
             
             </React.Fragment>
           )
         })
        }
     </div>

     <form id="form-file-upload3" style={{cursor:'pointer',border:'1px solid transparent'}} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
         <input ref={addRef} type="file" id="input-file-upload" multiple={true} onChange={handleAdd} accept=".wav"/>
           <label id="label-file-upload" htmlFor="input-file-upload" className={dragActive ? "drag-active" : "" }>
               <div className="TrackDropBox" style={{backgroundImage:`url(${UploadTrackBox})`,backgroundSize:'90%',backgroundPosition:'center',backgroundRepeat:'no-repeat'}}>
                 <span className="CoverartText">  
                 <Trans i18nKey="Toaddtracks" components={{1:<br/>}} >
                 To add tracks, drag and drop or
                </Trans>
                     <button className="upload-button" onClick={onAddTrackClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                         {t('Browseyourfiles')} 
                           </button> 
                 </span>
               </div>
           </label>
       { dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleAppDrop}></div> }
       </form>

       <div style={{display:'flex',flexDirection:'row',marginTop:'3.5em',paddingBottom:'4em'}}>
         <div className="BackBtn2" onClick={()=>{
            {/** PENDING */}
            // setPageNo(3);
            if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
              navigate("/Dashboard/releasemusic/albumdetails");
            }
  
            if(decodeToken(cookies.get('token')).info.role==="label"){
              navigate("/dashboard/label/releasemusic/albumdetails")
            }
           
            topFunction()}}>
           {t('Back')}
         </div>

       {
         nextBtn &&
             <div className="NextBtn2" onClick={()=>{
                                               // ConnectAssetstoProduct();
                                               {/** PENDING */}
                                            //    setPageNo(5);
                                            //    ChangeCollaborator(null,null,CollaboratorId,0); 
                                            //    setCheckCollaboratorArr(Math.random())
                                            if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                                              navigate("/Dashboard/releasemusic/royaltysplit");
                                            }
                                  
                                            if(decodeToken(cookies.get('token')).info.role==="label"){
                                              navigate("/dashboard/label/releasemusic/royaltysplit")
                                            }
                                              
                                               topFunction();}}>
           {t('Next')}
           <div className="PostLoginBtnOverlay"/>
         </div>
       }

       {
         !nextBtn &&
             <div className="NextBtn2" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
           {t('Next')}
         </div>
       }
         
       </div>

       <ReactModal
                            isOpen={deletePopup}
                            overlayClassName="Overlay"
                            contentLabel="Example Modal"
                            onRequestClose={closeDeletePopup} // closes the modal when the user presses the escape key
                            shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                            style={{ 
                                content:{
                                width:'32.18em',
                                height:'12.68em',
                                margin:'auto',
                                backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                borderRadius:'8px',
                                border:'0.5px solid rgba(255,255,255,25%)'
                                }
                            }}
                            >
                                
                                <div className="popupheaderinfo">Remove?</div>
                                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setDeletePopup(false)}}/>
                                   

                                

                                    <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Do you want to remove this item from the list?</span>
                                   
                                   
                                   
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'1em'}}>
                                        <div className="GoBackBtn" style={{paddingTop:'0.75em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setDeletePopup(false)}}>
                                            Cancel
                                        </div>

                                        <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{deletesong(deleteTrackIndex);setDeletePopup(false)}}>
                                            Yes, Remove
                                            <div className="PostLoginBtnOverlay"/>
                                        </div>
                                    </div>
        </ReactModal>

       <ReactModal
          isOpen={createArtistPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'38em',
              height:'25em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'flex-start',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)',
              zIndex:'100',
              paddingLeft:'2em',
              overflow:'visible'
            }
          }}
        >
          <div className="CreateArtistTxt">Create Artist</div>

          <span className="TrackDetailsInputHeader">
                      Artist name <span style={{color:'#E91353'}}>*</span>
                  </span>

                 
                  <input
                        value={newArtistName}
                        onChange={e =>{setnewArtistName(e.target.value);}} 
                        className='TrackDetailsInput'
                        type='text'
                        placeholder={"Enter artist's name"}
                        style={{width:'34em'}}
                        />

                  <div style={{display:'flex',flexDirection:'row',position:'relative'}}>
                    <div className="TrackDetailsInputHeader">
                        ISNI 
                    </div>
                    <img src={DisclaimerPopup} style={{width:'1em',height:'1em',marginTop:'-0.1em',marginLeft:'0.5em',padding:'0.4em'}} className="DisclaimerHover" onMouseOver={()=>setAddArtistDisclaimer(true)} onMouseLeave={()=>setAddArtistDisclaimer(false)}/>
                    {  
                                    addArtistDisclaimer &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-15.5em',marginLeft:'-3.8em'}} onMouseOver={()=>setAddArtistDisclaimer(true)} onMouseLeave={()=>setAddArtistDisclaimer(false)}>
                                        <div className='DisclaimerContainer' style={{width:'15.43em'}}>
                                        ISNI (International Standard Name Identifier) is a unique identifier for artists and contributors. It ensures correct mapping of works across digital platforms. An ISNI consists of 16 digits, with the last character being a check digit or 'X'.
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.1em',top:'14.5em'}}/>
                                      </div>
                                    }
                      
                  </div>

                  
                  <input
                        value={newArtistISNI}
                        onChange={e =>{setnewArtistISNI(e.target.value);}} 
                        className='TrackDetailsInput'
                        type='text'
                        placeholder={"Enter artist's ISNI"}
                        style={{width:'34em'}}
                        />

          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'0em',marginTop:'2em'}}>
          <div className="CancelTrackBtn" style={{cursor:'pointer'}} onClick={()=>{
                                                                                     setnewArtistName("")
                                                                                     setnewArtistISNI("")
                                                                                    setCreateArtistPopup(false);
                                                                                    setTrackPopup(true)
                                                                                    setPopupState("In modal")
                                                                                   }}>
            {t('Cancel')} 
          </div>

          {
            (newArtistName.length===0 || newArtistISNI.length===0) 
            &&
            <div className="SaveTrackBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
            Create
            </div>
          }
          
          {
            newArtistName.length!==0 && newArtistISNI.length!==0 &&
            <div className="SaveTrackBtn" onClick={()=>{ setnewArtistName("")
                                                        setnewArtistISNI("")
                                                        setCreateArtistPopup(false)
                                                        setTrackPopup(true)
                                                        setPopupState("In modal")}}
                                                        style={{cursor:'pointer'}}>
           Create
            <div className="PostLoginBtnOverlay"/>
            </div>
          }
         
         </div>

       
                  
      </ReactModal>

      <ReactModal
          isOpen={addContributorPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'38em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'flex-start',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)',
              zIndex:'100',
              paddingLeft:'2em',
              overflow:'visible'
            }
          }}
        >
          <div className="CreateArtistTxt">Contributor Details</div>

          <span className="TrackDetailsInputHeader">
                      Contibutor <span style={{color:'#E91353'}}>*</span>
                  </span>

                 
                  <Select options={fugaPersonId} value={contributor} onChange={changeContributorHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Type to search for contibutor"
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
               

                 
                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                      Roles <span style={{color:'#E91353'}}>*</span>
                  </span>

                  <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',marginTop:'1em'}}>
                  {
                    artistRoles.map((role,index)=>{
                      return <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,16%)',borderRadius:'40px',paddingTop:'0.5em',paddingBottom:'0.5em',paddingLeft:'1em',paddingRight:'1em',marginRight:'1em'}}>
                                <div className="ArtistRole">{role.label}</div>
                                <img src={crossicon} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}} onClick={()=>deleterole(index)}/>
                            </div>
                    })
                  }
                  
                      
                  {
                    roleToggle &&
                    <Select options={roleOptions} value={role}  onChange={changeRoleHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Type to search for role"
                    isSearchable
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
                }
                
                  {
                    !roleToggle &&
                    <div className="AddAnotherBtn" style={{cursor:'pointer',marginTop:'1em'}} onClick={()=>setRoleToggle(true)}>
                    + Add role
                    </div>
                  }
                 

                  </div>
                      
                

                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                      Instruments 
                  </span>

                  
                  <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',marginTop:'1em'}}>
                  {
                    artistInstuments.map((inst,index)=>{
                      return <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,16%)',borderRadius:'40px',paddingTop:'0.5em',paddingBottom:'0.5em',paddingLeft:'1em',paddingRight:'1em',marginRight:'1em'}}>
                                <div className="ArtistRole">{inst.label}</div>
                                <img src={crossicon} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}} onClick={()=>deleteInstrument(index)}/>
                            </div>
                    })
                  }
                  
                      
                  {
                    instrumentToggle &&
                    <Select options={instrumentOptions} value={instrument}   onChange={changeInstrumentHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Type to search for instrument"
                    isSearchable
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
                }
                
                  {
                    !instrumentToggle &&
                    <div className="AddAnotherBtn" style={{cursor:'pointer',marginTop:'1em'}} onClick={()=>setInstumentToggle(true)}>
                    + Add instrument
                    </div>
                  }
                 

                  </div>

                 

          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'0em',marginTop:'2em'}}>
          <div className="CancelTrackBtn" style={{cursor:'pointer'}} onClick={()=>{
                                                                                     setContributor("")
                                                                                     setRole("")
                                                                                     setInstruments("")
                                                                                     setArtistRoles([])
                                                                                     setArtistInstruments([])
                                                                                    setAddContributorPopup(false);
                                                                                    setTrackPopup(true)
                                                                                    setPopupState("In modal")
                                                                                  }}>
            {t('Cancel')} 
          </div>

          {
            (contributor.length===0 || role.length===0 ) 
            &&
            <div className="SaveTrackBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
            Save
            </div>
          }
          
          {
            contributor.length!==0 && role.length!==0  &&
            <div className="SaveTrackBtn" onClick={()=>{ 
                                                        addContributor()
                                                        setContributor("")
                                                        setRole("")
                                                        setInstruments("")
                                                        setArtistRoles([])
                                                        setArtistInstruments([])
                                                        setAddContributorPopup(false)
                                                        setTrackPopup(true)
                                                        setPopupState("In modal")
                                                        }}
                                                        style={{cursor:'pointer'}}>
           Save
            <div className="PostLoginBtnOverlay"/>
            </div>
          }
         
         </div>
         </ReactModal>

         <ReactModal
          isOpen={editContributorPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'38em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'flex-start',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)',
              zIndex:'100',
              paddingLeft:'2em',
              overflow:'visible'
            }
          }}
        >
          <div className="CreateArtistTxt">Contributor Details</div>

          <span className="TrackDetailsInputHeader">
                      Contibutor <span style={{color:'#E91353'}}>*</span>
                  </span>

                  <Select options={fugaPersonId} value={contributor} onChange={changeContributorHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Type to search for contibutor"
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
               

                 
                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                      Roles <span style={{color:'#E91353'}}>*</span>
                  </span>

                  <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',marginTop:'1em'}}>
                  {
                    artistRoles.map((role,index)=>{
                      return <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,16%)',borderRadius:'40px',paddingTop:'0.5em',paddingBottom:'0.5em',paddingLeft:'1em',paddingRight:'1em',marginRight:'1em'}}>
                                <div className="ArtistRole">{role.label}</div>
                                <img src={crossicon} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}} onClick={()=>deleterole(index)}/>
                            </div>
                    })
                  }
                  
                      
                  {
                    roleToggle &&
                    <Select options={roleOptions} value={role}  onChange={changeRoleHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Type to search for role"
                    isSearchable
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
                }
                
                  {
                    !roleToggle &&
                    <div className="AddAnotherBtn" style={{cursor:'pointer',marginTop:'1em'}} onClick={()=>setRoleToggle(true)}>
                    + Add role
                    </div>
                  }
                 

                  </div>
                      
                

                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                      Instruments 
                  </span>

                  
                  <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',marginTop:'1em'}}>
                  {
                    artistInstuments.map((inst,index)=>{
                      return <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,16%)',borderRadius:'40px',paddingTop:'0.5em',paddingBottom:'0.5em',paddingLeft:'1em',paddingRight:'1em',marginRight:'1em'}}>
                                <div className="ArtistRole">{inst.label}</div>
                                <img src={crossicon} style={{width:'1.25em',height:'1.25em',cursor:'pointer'}} onClick={()=>deleteInstrument(index)}/>
                            </div>
                    })
                  }
                  
                      
                  {
                    instrumentToggle &&
                    <Select options={instrumentOptions} value={instrument}   onChange={changeInstrumentHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Type to search for instrument"
                    isSearchable
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
                }
                
                  {
                    !instrumentToggle &&
                    <div className="AddAnotherBtn" style={{cursor:'pointer',marginTop:'1em'}} onClick={()=>setInstumentToggle(true)}>
                    + Add instrument
                    </div>
                  }
                 

                  </div>

                 

          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'0em',marginTop:'2em'}}>
          <div className="CancelTrackBtn" style={{cursor:'pointer'}} onClick={()=>{
                                                                                     setContributor("")
                                                                                     setRole("")
                                                                                     setInstruments("")
                                                                                     setArtistRoles([])
                                                                                     setArtistInstruments([])
                                                                                    setEditContibutorPopup(false);
                                                                                    setTrackPopup(true)
                                                                                    setPopupState("In modal")
                                                                                  }}>
            {t('Cancel')} 
          </div>

          {
            (contributor.length===0 || artistRoles.length===0 ) 
            &&
            <div className="SaveTrackBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
            Save
            </div>
          }
          
          {
            contributor.length!==0 && artistRoles.length!==0  &&
            <div className="SaveTrackBtn" onClick={()=>{  
                                                        editContributor(contributorId)
                                                        setContributor("")
                                                        setRole("")
                                                        setInstruments("")
                                                        setArtistRoles([])
                                                        setArtistInstruments([])
                                                        setEditContibutorPopup(false)
                                                        setTrackPopup(true)
                                                        setPopupState("In modal")
                                                       }}
                                                        style={{cursor:'pointer'}}>
           Save
            <div className="PostLoginBtnOverlay"/>
            </div>
          }
         
         </div>
         </ReactModal>

      
         <ReactModal
          isOpen={addPublisherPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'38em',
              height:'32em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'flex-start',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)',
              zIndex:'100',
              paddingLeft:'2em',
              overflow:'visible'
            }
          }}
        >
          <div className="CreateArtistTxt">Add Publisher</div>

          <span className="TrackDetailsInputHeader">
                      Publisher <span style={{color:'#E91353'}}>*</span>
                  </span>

                  <Select options={publisherOptions} value={publishers} onChange={changePublisherHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select publisher"
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
               

                 
                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                      Composer/Lyricist 
                  </span>

                 <Select options={fugaPersonId} value={composer}  onChange={changeComposerHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select composer/lyricist"
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />

                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                    Link composer/lyricist to this publisher
                  </span>
                      
                

          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'0em',marginTop:'2em'}}>
          <div className="CancelTrackBtn" style={{cursor:'pointer'}} onClick={()=>{
                                                                                  setComposer("")
                                                                                  setPublisher("")
                                                                                    setAddPublisherPopup(false);
                                                                                    setTrackPopup(true)
                                                                                    setPopupState("In modal")
                                                                                   }}>
            {t('Cancel')} 
          </div>

          {
            publishers.length===0  
            &&
            <div className="SaveTrackBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
            Save
            </div>
          }
          
          {
            publishers.length!==0  &&
            <div className="SaveTrackBtn" onClick={()=>{ 
                                                        addPublisher()
                                                        setComposer("")
                                                        setPublisher("")
                                                        setAddPublisherPopup(false)
                                                        setTrackPopup(true)
                                                        setPopupState("In modal")}}
                                                        style={{cursor:'pointer'}}>
           Save
            <div className="PostLoginBtnOverlay"/>
            </div>
          }
         
         </div>
         </ReactModal>

         <ReactModal
          isOpen={editPublisherPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'38em',
              height:'32em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'flex-start',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)',
              zIndex:'100',
              paddingLeft:'2em',
              overflow:'visible'
            }
          }}
        >
          <div className="CreateArtistTxt">Add Publisher</div>

          <span className="TrackDetailsInputHeader">
                      Publisher <span style={{color:'#E91353'}}>*</span>
                  </span>

                  <Select options={publisherOptions} value={publishers} onChange={changePublisherHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select publisher"
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />
               

                 
                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                      Composer/Lyricist 
                  </span>

                 <Select options={fugaPersonId} value={composer}  onChange={changeComposerHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select composer/lyricist"
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />

                  <span className="TrackDetailsInputHeader" style={{marginTop:'1.5em'}}>
                    Link composer/lyricist to this publisher
                  </span>
                      
                

          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'0em',marginTop:'2em'}}>
          <div className="CancelTrackBtn" style={{cursor:'pointer'}} onClick={()=>{
                                                                                  setComposer("")
                                                                                  setPublisher("")
                                                                                    setEditPublisherPopup(false);
                                                                                    setTrackPopup(true)
                                                                                    setPopupState("In modal")
                                                                                   }}>
            {t('Cancel')} 
          </div>

          {
            (publishers.length===0 ) 
            &&
            <div className="SaveTrackBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
            Save
            </div>
          }
          
          {
            publishers.length!==0  &&
            <div className="SaveTrackBtn" onClick={()=>{ 
                                                        editPublisher(publisherId)
                                                        setComposer("")
                                                        setPublisher("")
                                                        setEditPublisherPopup(false)
                                                        setTrackPopup(true)
                                                        setPopupState("In modal")}}
                                                        style={{cursor:'pointer'}}>
           Save
            <div className="PostLoginBtnOverlay"/>
            </div>
          }
         
         </div>
         </ReactModal>
      
      {/**TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT */}
      <ReactModal
          isOpen={trackPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'53em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)',
              zIndex:'100'
            }
          }}
        >
          <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'47.5em',paddingLeft:'0em',paddingRight:'0em',borderBottom:'rgba(255,255,255,20%) 1px solid',paddingTop:'0em',paddingBottom:'0em'}}>
            <div className="TrackDetailsHeader">
            {t('Trackdetails')} 
            </div>
            <img src={crossicon} style={{height:'1.5em',width:'1.5em',cursor:'pointer',paddingRight:'2em'}} 
            onClick={()=>{
              if(unsavedChanges){
                setTrackPopup(false);
                setPopupState("In modal")
                setUnsavedChangesPopup(true)
              }else{
                setTrackPopup(false)
              }
              }}/>
          </div>

          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',width:'47.5em',paddingTop:'2em'}}>
              <div className="TrackDetailsSectHeader">GENERAL INFORMATION</div>
              <div style={{display:'flex',flexDirection:'column',paddingLeft:'5em'}}>
                  <span className="TrackDetailsInputHeader">
                      Title <span style={{color:'#E91353'}}>*</span>
                  </span>

                  {
                      files[popupId]!==undefined && files[popupId].Tracktitle.length===0 &&
                        <input
                        value={Trackname}
                        onChange={e =>{setTrackname(e.target.value);setUnsavedChanges(true)}} 
                        className='TrackDetailsInput'
                        type='text'
                        placeholder={"Add title for ".concat(files[popupId].Asset_file.name)}
                        style={{width:'25em'}}
                        />
                    }

                    {
                      files[popupId]!==undefined && files[popupId].Tracktitle.length!==0 &&
                        <input
                        value={Trackname}
                        onChange={e =>{setTrackname(e.target.value);setUnsavedChanges(true)}} 
                        className='TrackDetailsInput'
                        type='text'
                        placeholder={files[popupId].Tracktitle}
                        style={{width:'25em'}}
                        />
                    }

                  <span className="TrackDetailsInputHeader">
                     Artist <span style={{color:'#E91353'}}>*</span>
                  </span>
                  
                  
                  {   
                  trackartists.length!==0 &&
                      <div style={{display:'flex',flexDirection:'column'}}>
                    {
                    trackartists.map((artist,index)=>{
                      return (  
                      <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',borderRadius:'4px',border:'1px solid rgba(255,255,255,40%)',alignItems:'center',paddingRight:'0.75em',paddingLeft:'0.75em',paddingTop:'0.75em',paddingBottom:'0.75em',marginTop:'0.4em'}}>
                      <div style={{display:'flex',flexDirection:'column'}}>
                      <div className="TrackArtistName">
                        {artist.name}
                      </div>
                      {
                        index === 0 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <PrimarySwitch/>
                          <div  className="TrackArtistRole">Primary</div>
                        </div>
                      }

                      { 
                        index === 1 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Featured1Switch/>
                          <div  className="TrackArtistRole">Featured</div>
                        </div>
                      }

                      { 
                        index === 2 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Featured2Switch/>
                          <div  className="TrackArtistRole">Featured</div>
                        </div>
                      }

                      {  
                        index === 3 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Featured3Switch/>
                          <div  className="TrackArtistRole">Featured</div>
                        </div>
                      } 
                      
                      {  
                        index === 4 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Featured4Switch/>
                          <div  className="TrackArtistRole">Featured</div>
                        </div>
                      } 

                      {  
                        index === 5 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Featured5Switch/>
                          <div  className="TrackArtistRole">Featured</div>
                        </div>
                      } 

                      {  
                        index === 6 &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Featured6Switch/>
                          <div  className="TrackArtistRole">Featured</div>
                        </div>
                      } 
                     
                    </div>
                    <img src={crossicon} style={{width:'1.5em',height:'1.5em',cursor:'pointer'}} onClick={()=>deleteArtist(index)}/>
                  </div>)
                    })
                  }
                  </div>
                  }
                 

                  {/* <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',borderRadius:'4px',border:'1px solid rgba(255,255,255,40%)',alignItems:'center',paddingRight:'0.75em',paddingLeft:'0.75em',paddingTop:'0.75em',paddingBottom:'0.75em',marginTop:'0.4em'}}>
                      <div style={{display:'flex',flexDirection:'column'}}>
                        <div className="TrackArtistName">
                          {artistName}
                        </div>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                            <PrimarySwitch/>
                            <div  className="TrackArtistRole">Primary</div>
                        </div>
                      </div>
                      <img src={crossicon} style={{width:'1.5em',height:'1.5em',cursor:'pointer'}}/>
                  </div> */}
                  
                  {
                   artistToggle &&
                    <Select options={fugaArtistId} value={trackartist} onChange={changeArtistHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      TrackDetailsColourStyles
                    }
                    />
                  }
                 
                 {/* <div onClick={()=>{setTrackPopup(false);setCreateArtistPopup(true)}} className="AddAnotherBtn" style={{cursor:'pointer',marginTop:'0.5em'}}>
                  + Add New
                 </div> */}

                  { 
                        !artistToggle && trackartists.length!==7 &&
                        <div className="AddAnotherBtn" style={{cursor:'pointer',marginTop:'0.5em'}} onClick={()=>setArtistToggle(true)}>
                          {t('Addanother')}
                        </div>
                      }

              </div>

            
          </div>

          <div style={{backgroundColor:'rgba(255,255,255,20%)',height:'1px',width:'95%',marginTop:'2em',marginBottom:'1em',color:'transparent'}}> 
          d
          </div>

            <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',width:'47.5em',paddingTop:'1em'}}>
              <span className="TrackDetailsSectHeader">CONTRIBUTORS<span style={{color:'#E91353'}}>&nbsp;*</span></span>
              <div style={{display:'flex',flexDirection:'column',paddingLeft:'5em',marginTop:'0em'}}>
                        {
                          trackContributors.length!==0 &&
                          <div style={{display:'flex',flexDirection:'column'}}>
                            {
                              trackContributors.map((value,index)=>{
                                return (
                                  <div style={{display:'flex',flexDirection:'row',position:'relative',justifyContent:'space-between',borderRadius:'4px',border:'1px solid rgba(255,255,255,40%)',alignItems:'center',paddingRight:'0.75em',paddingLeft:'0.75em',paddingTop:'0.75em',paddingBottom:'0.75em',marginTop:'0.4em',maxWidth:'25em',width:'25em'}}>
                                  <div style={{display:'flex',flexDirection:'column'}}>
                                    <div className="TrackArtistName">
                                      {value.name}
                                      </div>

                                    <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap'}}>
                                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',maxWidth:'15em'}}>
                                      {
                                        value.roles.map((role,index)=>{
                                          return  (
                                            <div>
                                              {
                                                (index===value.roles.length-1 &&  value.instruments.length===0) &&
                                                <div  className="ArtistInfo" style={{marginRight:'0em'}}>
                                                           {role.label}
                                                  </div>
                                              }
                                             {
                                                (index===value.roles.length-1 &&  value.instruments.length!==0) &&
                                                <div  className="ArtistInfo" style={{marginRight:'0em'}}>
                                                           {role.label},
                                                  </div>
                                              }

                                            {
                                                (index!==value.roles.length-1) &&
                                                <div  className="ArtistInfo" style={{marginRight:'0em'}}>
                                                           {role.label},
                                                  </div>
                                              }
                                                  
                                            </div>
                                            )
                                        })
                                      }
                                      </div>

                                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',maxWidth:'15em'}}>
                                      {
                                        value.instruments.map((inst,index)=>{
                                          return  (<div>
                                          {
                                            (index===value.instruments.length-1) &&
                                            <div  className="ArtistInfo" style={{marginRight:'0em'}}>
                                                       {inst.label}
                                              </div>
                                          }

                                        {
                                            (index!==value.instruments.length-1) &&
                                            <div  className="ArtistInfo" style={{marginRight:'0em'}}>
                                                       {inst.label},
                                              </div>
                                          }
                                              
                                        </div>)
                                        })
                                      }
                                      </div>
                                    </div>
                                     
                                    </div>
                                    <img src={MoreTrackInfo} style={{width:'1.5em',height:'1.5em',cursor:'pointer'}} onMouseOver={()=>toggleContributorEdit(index,true)} onMouseLeave={()=>toggleContributorEdit(index,false)}/>

                                    {
                                      value.editbox &&
                                      <div style={{display:'flex',position:'absolute',right:'0',flexDirection:'column',justifyContent:'center',width:'6.5em',height:'5.5em',borderRadius:'4px',border:'1px solid rgba(255,255,255,60%)',backgroundColor:'#2A333D'}} onMouseOver={()=>toggleContributorEdit(index,true)} onMouseLeave={()=>toggleContributorEdit(index,false)}>
                                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'1.125em',marginBottom:'0.3em'}}>
                                          <img src={EditIcon} style={{width:'1.23em',height:'1.23em',cursor:'pointer'}}/>
                                          <div className="EditMenuOption" onClick={()=>{setContributorId(index);setPopupState("In modal");setTrackPopup(false);setEditContibutorPopup(true)}}>Edit</div>
                                        </div>

                                        <div style={{display:'flex',flexDirection:'row',marginLeft:'1.125em'}}>
                                          <img src={DeleteIcon} style={{width:'1.5em',height:'1.5em',alignItems:'center',cursor:'pointer'}}/>
                                          <div className="EditMenuOption" style={{color:'#FF8686',marginLeft:'0.3em',marginTop:'0.1em'}} onClick={()=>DeleteContributor(index)}>Delete</div>
                                        </div>
                                      </div>
                                    }
                                    
                                  </div>
                                )
                              })
                            }
                        
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'1em',marginLeft:'-0.4em'}}  onClick={()=>{setPopupState("In modal");setTrackPopup(false);setAddContributorPopup(true)}}>
                         + Add Another
                        </div>
                         </div>
                          }

                      {
                          trackContributors.length===0 &&
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'0em',marginLeft:'-0.4em'}}  onClick={()=>{setPopupState("In modal");setTrackPopup(false);setAddContributorPopup(true)}}>
                         + Add contributor
                        </div>
                      }
                        {/* {
                          contributor.length!==0 &&
                          <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',borderRadius:'4px',border:'1px solid rgba(255,255,255,40%)',alignItems:'center',paddingRight:'0.75em',paddingLeft:'0.75em',paddingTop:'0.75em',paddingBottom:'0.75em',marginTop:'0.4em',width:'100%'}}>
                          <div style={{display:'flex',flexDirection:'column'}}>
                            <div className="TrackArtistName">
                              {contributor.value}
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}} className="ArtistInfo">
                                 {role.value},{instrument.value}
                              </div>
                            </div>
                            <img src={MoreTrackInfo} style={{width:'1.5em',height:'1.5em',cursor:'pointer'}}/>
                        </div>
                          }
                        {
                          contributor.length===0 &&
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'0em',marginLeft:'-1em'}} onClick={()=>{setTrackPopup(false);setAddContributorPopup(true)}}>
                         + Add contributors
                        </div>
                        } */}
                      
                </div>
            </div>

            <div style={{backgroundColor:'rgba(255,255,255,20%)',height:'1px',width:'95%',marginTop:'2em',marginBottom:'1em',color:'transparent'}}> 
          d
          </div>

          <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',width:'47.5em',paddingTop:'1em'}}>
              <div className="TrackDetailsSectHeader">PUBLISHERS</div>
              <div style={{display:'flex',flexDirection:'column',paddingLeft:'5em',marginTop:'0em'}}>
                         {
                          trackPublishers.length!==0 &&
                          <div style={{display:'flex',flexDirection:'column'}}>
                            {
                              trackPublishers.map((publisher,index)=>{
                                return (
                                  <div style={{display:'flex',flexDirection:'row',position:'relative',justifyContent:'space-between',borderRadius:'4px',border:'1px solid rgba(255,255,255,40%)',alignItems:'center',paddingRight:'0.75em',paddingLeft:'0.75em',paddingTop:'0.75em',paddingBottom:'0.75em',marginTop:'0.4em',width:'100%'}}>
                                  <div style={{display:'flex',flexDirection:'column'}}>
                                    <div className="TrackArtistName">
                                      {publisher.name}
                                      </div>

                                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginRight:'16.9em'}} className="ArtistInfo">
                                        {publisher.composer}
                                      </div>
                                    </div>
                                    <img src={MoreTrackInfo} style={{width:'1.5em',height:'1.5em',cursor:'pointer'}} onMouseOver={()=>togglePublisherEdit(index,true)} onMouseLeave={()=>togglePublisherEdit(index,false)}/>

                                    {
                                      publisher.editbox &&
                                      <div style={{display:'flex',position:'absolute',right:'0',flexDirection:'column',justifyContent:'center',width:'6.5em',height:'5.5em',borderRadius:'4px',border:'1px solid rgba(255,255,255,60%)',backgroundColor:'#2A333D'}} onMouseOver={()=>togglePublisherEdit(index,true)} onMouseLeave={()=>togglePublisherEdit(index,false)}>
                                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'1.125em',marginBottom:'0.3em'}}>
                                          <img src={EditIcon} style={{width:'1.23em',height:'1.23em',cursor:'pointer'}}/>
                                          <div className="EditMenuOption" onClick={()=>{setPublisherId(index);setPopupState("In modal");setTrackPopup(false);setEditPublisherPopup(true)}}>Edit</div>
                                        </div>

                                        <div style={{display:'flex',flexDirection:'row',marginLeft:'1.125em'}}>
                                          <img src={DeleteIcon} style={{width:'1.5em',height:'1.5em',alignItems:'center',cursor:'pointer'}}/>
                                          <div className="EditMenuOption" style={{color:'#FF8686',marginLeft:'0.3em',marginTop:'0.1em'}} onClick={()=>DeletePublisher(index)}>Delete</div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                )
                              })
                            }
                        
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'1em',marginLeft:'-0.4em'}}  onClick={()=>{setPopupState("In modal");setTrackPopup(false);setAddPublisherPopup(true)}}>
                         + Add Another
                        </div>
                         </div>
                          }

                      {
                          trackPublishers.length===0 &&
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'0em',marginLeft:'-0.4em'}}  onClick={()=>{setPopupState("In modal");setTrackPopup(false);setAddPublisherPopup(true)}}>
                         + Add publishers
                        </div>
                      }
                </div>
            </div>

            <div style={{backgroundColor:'rgba(255,255,255,20%)',height:'1px',width:'95%',marginTop:'2em',marginBottom:'1em',color:'transparent'}}> 
            d
            </div>

            <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',width:'47.5em',paddingTop:'1em'}}>
              <div className="TrackDetailsSectHeader">LYRICS</div>
              <div style={{display:'flex',flexDirection:'column',paddingLeft:'5em',marginTop:'0em'}} className={lyricsclass}>

                        {
                          lyricsclass==="LyricsModuleOpen" &&
                          <div>

                            {
                              lyrics.length===0 &&
                               <textarea  rows="4" cols="50" className='TrackLyricsTrackArea' value={lyrics} onChange={e =>{setLyrics(e.target.value);setUnsavedChanges(true);}}   />
                            }

                            {
                              lyrics.length!==0 &&
                               <textarea  rows="4" cols="50" className='TrackLyricsTrackArea' defaultValue={lyrics} onChange={e =>{setLyrics(e.target.value);setUnsavedChanges(true);}}   />
                            }
                         
                         
                         
                          </div>
                        }


                        {
                          lyricsclass==="LyricsModule" &&
                          <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'0em',marginLeft:'-0.4em'}} onClick={()=>setLyricsClass("LyricsModuleOpen")}>
                          + Add lyrics
                          </div>
                        }
                       
                      
                </div>
            </div>

            <div style={{backgroundColor:'rgba(255,255,255,20%)',height:'1px',width:'95%',marginTop:'2em',marginBottom:'1em',color:'transparent'}}> 
            d
            </div>

            <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',width:'47.5em',paddingTop:'2em'}}>
              <div className="TrackDetailsSectHeader">LANGUAGE</div>
              <div style={{display:'flex',flexDirection:'column',paddingLeft:'5em',overflow:'visible'}} className={tracklanguageclass}>
                  <span className="TrackDetailsInputHeader">
                      Audio Language <span style={{color:'#E91353'}}>*</span>
                  </span>

                  <Select options={LanguageOptions} value={AudioLanguage} onChange={changeLanguageHandler} 
                        components={{
                          IndicatorSeparator: () => null
                        }}
                        placeholder="Select"
                        styles={
                          TrackDetailsColourStyles
                        }
                        />
                  {
                    advanceTrackFields &&
                    <div style={{display:'flex',flexDirection:'column'}}>
                  <span className="TrackDetailsInputHeader" style={{marginTop:'1em'}}>
                    Metadata Language 
                  </span>

                  <Select options={LanguageOptions} value={trackMetadatLanguage} onChange={changeMetaLanguageHandler} 
                        components={{
                          IndicatorSeparator: () => null
                        }}
                        placeholder="Select"
                        styles={
                          TrackDetailsColourStyles
                        }
                        />

                  <span className="TrackDetailsInputHeader" style={{marginTop:'1em'}}>
                    Explicit Content
                  </span>

                  <Select options={ExplicitContentOptions} value={explicitContent} onChange={changeExplicitHandler} 
                        components={{
                          IndicatorSeparator: () => null
                        }}
                        placeholder="Select"
                        styles={
                          TrackDetailsColourStyles
                        }
                        />
                    </div>
                  }
                  



                      {
                        !advanceTrackFields &&
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'1.5em',marginLeft:'0em'}} onClick={()=>{setAdvanceTrackFields(true);setTrackLanguageClass("TrackLanguageModuleOpen")}}>
                        Show advanced fields
                        </div>
                      }

                      {
                        advanceTrackFields &&
                        <div className="AddTrackDetailsBtn" style={{cursor:'pointer',marginTop:'1.5em',marginLeft:'0em'}} onClick={()=>{setAdvanceTrackFields(false);setTrackLanguageClass("TrackLanguageModuleClosed")}}>
                        Hide advanced fields
                        </div>
                      }
                    

              </div>

            
          </div>
         

         <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'0em',marginTop:'2em'}}>
          <div className="CancelTrackBtn" style={{cursor:'pointer'}} onClick={()=>{setPopupState("In modal");setTrackPopup(false)
                                                                                   setUnsavedChangesPopup(true)}}>
            {t('Cancel')}
          </div>

         
          {
            (Trackname.length===0 || trackartists.length===0 || AudioLanguage.length===0 || trackContributors.length===0) &&
            <div className="SaveTrackBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
            {t('Save')}
            <div className="PostLoginBtnOverlay"/>
            </div>
          }

          {
            Trackname.length!==0 && trackartists.length!==0 && AudioLanguage.length!==0 && trackContributors.length!==0 &&
            <div className="SaveTrackBtn" onClick={()=>{
                                                        handleSubmitTrackDetails()
                                                        setTrackPopup(false)
                                                        setTrackname("")
                                                        setTrackArtists([])
                                                        setTrackArtist("")
                                                        setArtistToggle(false)
                                                        setTrackContributors([])
                                                        setTrackPublishers([])
                                                        setLyrics("")
                                                        setAudioLanguage("")
                                                        setTrackMetadataLanguage("")
                                                        setExplicitContent("")
                                                        setCheckAssetArr(Math.random())}} 
                                                        style={{cursor:'pointer'}}>
            {t('Save')}
            <div className="PostLoginBtnOverlay"/>
            </div>
          }
         
         </div>

        </ReactModal>

        <ReactModal
                            isOpen={unsavedChangesPopup}
                            overlayClassName="Overlay"
                            contentLabel="Example Modal"
                            onRequestClose={closeUnsavedChangesPopup} // closes the modal when the user presses the escape key
                            shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                            style={{
                                content:{
                                width:'32.18em',
                                height:'16.68em',
                                margin:'auto',
                                backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                borderRadius:'8px',
                                border:'0.5px solid rgba(255,255,255,25%)'
                                }
                            }}
                            >
                                
                                <div className="popupheaderinfo">You have unsaved changes</div>
                                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setPopupState("In modal");setTrackPopup(true);setUnsavedChangesPopup(false)}}/>
                                   

                                

                                    <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Any unsaved progress will be lost if you choose to close. Are you sure you want to close? </span>
                                   
                                   
                                   
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'1em'}}>
                                        <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setPopupState("In modal");setTrackPopup(true);setUnsavedChangesPopup(false)}}>
                                            Cancel
                                        </div>

                                        <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{
                                                                                                                              setTrackPopup(false);  
                                                                                                                              setUnsavedChangesPopup(false);
                                                                                                                                setTrackname("")
                                                                                                                                setTrackArtists([])
                                                                                                                                setTrackArtist("")
                                                                                                                                setArtistToggle(false)
                                                                                                                                setTrackContributors([])
                                                                                                                                setTrackPublishers([])
                                                                                                                                setLyrics("")
                                                                                                                                setAudioLanguage("")
                                                                                                                                setTrackMetadataLanguage("")
                                                                                                                                setExplicitContent("")
                                                                                                                                setCheckAssetArr(Math.random())}}>
                                            Yes, Close
                                            <div className="PostLoginBtnOverlay"/>
                                        </div>
                                    </div>
        </ReactModal>

   </div>
        
    );
}

export default TrackDetails;

function PrimarySwitch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
      primaryChecked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }
  
  function Featured1Switch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
      featured1Checked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }
  
  function Featured2Switch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
      featured2Checked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }
  
  function Featured3Switch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
      featured3Checked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }
  
  
  function Featured4Switch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
      featured4Checked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }
  
  
  function Featured5Switch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
      featured5Checked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }
  
  
  function Featured6Switch(props) {
    const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
     
    useEffect(()=>{
       featured6Checked=checked
    },[checked])
  
    const stateClasses = {
      'Switch-checked': checked,
      'Switch-disabled': disabled,
      'Switch-focusVisible': focusVisible,
    };
  
    return (
      <TrackSwitchRoot className={clsx(stateClasses)}>
        <TrackSwitchThumb className={clsx(stateClasses)} />
        <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
      </TrackSwitchRoot>
    );
  }

  const TrackSwitchRoot = styled('span')(
    ({ theme }) => `
    box-sizing: border-box;
    font-size: 0;
    position: relative;
    display: inline-block;
    width: 38px;
    height: 22px;
    margin: 10px;
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? '#E91353' : 'rgba(255, 255, 255, 60%)'};
    
    border-radius: 24px;
    box-shadow: inset 0px 1px 1px ${
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(0, 0, 0, 0.05)'
    };
  
    &:hover {
      background: ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(255, 255, 255, 60%)'};
    }
      
    &.Switch-focusVisible {
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(255, 255, 255, 60%)'};
    }
  
    &.Switch-disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  
    &.Switch-checked {
     
      background: ${'#E91353'};
      box-shadow: inset 0px 1px 1px ${
        theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.05)'
      };
      &.Switch-focusVisible {
        box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(255, 255, 255, 60%)'};
      }
    }
    
    `,
  );
  
  const TrackSwitchInput = styled('input')`
    box-sizing: border-box;
    cursor: inherit;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    margin: 0;
  `;
  
  const TrackSwitchThumb = styled('span')(
    ({ theme }) => `
    box-sizing: border-box;
    display: block;
    width: 16px;
    height: 16px;
    top: 3px;
    left: 2px;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 60%);
    
    position: relative;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
    box-shadow: 0px 1px 2px
      ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.1)'};
  
    &.Switch-checked {
      left: 17px;
      background-color: #fff;
     
    }
  `,
  );